window.SUBX = {};

function parseJSON(value, fallback = null) {
  try {
    if (!value) return fallback;

    if (typeof value !== 'string') {
      return value;
    }

    value = value.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');

    let parsed = JSON.parse(value);

    if (Array.isArray(parsed) && parsed.length && typeof parsed[0] === 'string') {
      parsed = parsed.map(item => {
        try {
          return JSON.parse(item.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&'));
        } catch (e) {
          return item;
        }
      });
    }

    return parsed;
  } catch (e) {
    console.warn('SUBX parseJSON failed', e);
    return fallback;
  }
}

function getCurrentSection() {
  const section = document.querySelector('[id^="shopify-section-"]:has(.easymanualsubsection)');
  if (!section) return null;
  return section;
}

function getCurrentVariantId(variantInput, productData) {
  const urlVariant = new URLSearchParams(window.location.search).get('variant');

  if (urlVariant) {
    return urlVariant;
  }

  if (variantInput?.value) {
    return variantInput.value;
  }

  return productData?.selected_or_first_available_variant?.id || null;
}

function refreshSUBX() {
  const section = getCurrentSection();
  if (!section) return null;

  const SUBS_ELEMENT = section.querySelector('.easymanualsubsection');
  if (!SUBS_ELEMENT) {
    console.warn('SUBX: Subscription element not found');
    return null;
  }

  const sectionId = SUBS_ELEMENT.dataset.sectionId || null;
  const productId = SUBS_ELEMENT.dataset.productId || null;
  const shopifySection = document.querySelector(`#shopify-section-${sectionId}`) || document.querySelector(`#QuickAdd-${productId}`) || SUBS_ELEMENT.closest('[id^="shopify-section-"]') || document;
  const forms = [...shopifySection.querySelectorAll('[action*="/cart/add"]')];
  const variantInput = forms[1]?.querySelector('[name="id"]') || forms[0]?.querySelector('[name="id"]') || null;
  const productData = parseJSON(SUBS_ELEMENT.dataset.productJsonData, {});

  Object.assign(window.SUBX, {
    SUBS_ELEMENT,sectionId,productId,shopifySection,forms,variantInput,
    currentVariantId:getCurrentVariantId(variantInput, productData),
    giftIcon:SUBS_ELEMENT.dataset.giftIcon || '',
    variantIds:parseJSON(SUBS_ELEMENT.dataset.variantsList,[]),
    productJson:parseJSON(SUBS_ELEMENT.dataset.subscriptionLargeData),
    variantMeta:parseJSON(SUBS_ELEMENT.dataset.variantsMeta),
    styleMeta:parseJSON(SUBS_ELEMENT.dataset.subxStyleSetting),
    productMeta:parseJSON(SUBS_ELEMENT.dataset.productMetaData),
    gatewayMode:SUBS_ELEMENT.dataset.gatewayMode || '',
  });

  return window.SUBX;
}

function handleSUBXChange(type, value) {
  refreshSUBX();

  toggleSubscribeButton();
  
  document.dispatchEvent(new CustomEvent(`subx:${type}-change`, {
    detail:{value,SUBX}
  }));
}

function setupPurchaseOptionObserver() { 
  SUBX.SUBS_ELEMENT?.querySelectorAll('.easymsgradiobig').forEach(input => {
    if (input.dataset.subxBound) return;

    input.dataset.subxBound = 'true';

    input.addEventListener('change', () => {
      handleSUBXChange('purchase-option', input.id);
    });
  });
}

function setupSellingPlanObserver() {
  SUBX.SUBS_ELEMENT?.querySelectorAll('.easymsgsamllradio').forEach(input => {
    if (input.dataset.subxBound) return;

    input.dataset.subxBound = 'true';

    input.addEventListener('change', () => {
      handleSUBXChange('selling-plan', {
        sellingPlanId:input.dataset.sellingPlanId,
        sellingPlanName:input.dataset.sellingPlanName
      });
    });
  });

  setupQuantityBreakObserver();
}

// The quantity-breaks layout changes the plan with a <select> and a checkbox, not a radio.
// Neither fires a DOM mutation on the widget, so setupWidgetObserver never sees them — without
// this, unticking "Subscribe & Save" would leave the Subscribe Now button on screen for what is
// now a one-time purchase, and switching tier would leave the popup on the old quantity.
function setupQuantityBreakObserver() {
  SUBX.SUBS_ELEMENT?.querySelectorAll('.easymsgqbplandropdown, .easymsgqbplancheckbox').forEach(input => {
    if (input.dataset.subxQbBound) return;
    input.dataset.subxQbBound = 'true';
    input.addEventListener('change', () => {
      // Run after the widget's own handler, whichever order the two were bound in — it is the
      // one that adds or removes the hidden input we then read.
      setTimeout(() => {
        handleSUBXChange('selling-plan', { sellingPlanId: getSelectedPlanId(), sellingPlanName: '' });
      }, 0);
    });
  });
}

function setupVariantObserver() {
  setupUrlObserver();
  const productData = parseJSON(SUBX.SUBS_ELEMENT.dataset.productJsonData, {});
  const variantInput = SUBX.variantInput;

  if (!variantInput) {
    console.warn('SUBX: Variant input not found');
    return;
  }

  SUBX.currentVariantId = getCurrentVariantId(variantInput, productData);

  variantInput.addEventListener('change', e => {
    onVariantChange(e.target.value);
  });

  variantInput.addEventListener('input', e => {
    onVariantChange(e.target.value);
  });

  SUBX.variantObserver?.disconnect();

  SUBX.variantObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        const newValue = variantInput.value;

        if (newValue !== SUBX.currentVariantId) {
          onVariantChange(newValue);
        }
      }
    }
  });

  SUBX.variantObserver.observe(variantInput,{
    attributes:true,
    attributeFilter:['value']
  });
}

function setupUrlObserver() {
  if (SUBX.urlObserverInitialized) return;

  SUBX.urlObserverInitialized = true;

  window.addEventListener('popstate', () => {
    onUrlChange();
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = (...args) => {
    originalPushState.apply(history,args);
    onUrlChange();
  };

  history.replaceState = (...args) => {
    originalReplaceState.apply(history,args);
    onUrlChange();
  };
}

function onUrlChange() {
  const newVariantId = new URLSearchParams(window.location.search).get('variant');
  if (newVariantId && newVariantId !== SUBX.currentVariantId) {
    onVariantChange(newVariantId);
  }
}

function onVariantChange(newVariantId) {
  if (newVariantId === SUBX.currentVariantId) return;

  SUBX.currentVariantId = newVariantId;

  SUBX.forms?.forEach(form => {
    const subscribeBtn = form.querySelector('.subx-subscribe-btn');
    if (subscribeBtn) subscribeBtn.style.display = 'none';
  });

  clearTimeout(SUBX.variantChangeTimeout);

  SUBX.variantChangeTimeout = setTimeout(() => {
    refreshSUBX();
    handleSUBXChange('variant', newVariantId);
  }, 300);
}

function setupWidgetObserver() {
  SUBX.widgetObserver?.disconnect();
  SUBX.widgetObserver = new MutationObserver(() => {
    refreshSUBX();
    toggleSubscribeButton();
    setupPurchaseOptionObserver();
    setupSellingPlanObserver();
    setupVariantObserver();
  });

  SUBX.widgetObserver.observe(SUBX.SUBS_ELEMENT,{
    childList:true,
    subtree:true
  });
}

function ensureSubscribeButtons() {
  SUBX.forms.forEach(form => {
    const nativeBtn = form.querySelector('button[type="submit"], input[type="submit"]');

    if (!nativeBtn) return;

    let subscribeBtn = form.querySelector('.subx__subscribe-btn');

    if (!subscribeBtn) {
      subscribeBtn = nativeBtn.cloneNode(true);
      subscribeBtn.classList.add('subx__subscribe-btn');

      subscribeBtn.removeAttribute('id');
      subscribeBtn.removeAttribute('ref');
      subscribeBtn.removeAttribute('name');

      Array.from(subscribeBtn.attributes).forEach(attr => {
        if (attr.name.startsWith('on:')) {
          subscribeBtn.removeAttribute(attr.name);
        }
      });

      subscribeBtn.type = 'button';
      subscribeBtn.disabled = false;
      subscribeBtn.textContent = 'Subscribe Now';
      subscribeBtn.style.display = 'none';
      // Add to cart and Subscribe Now are now BOTH on screen (29 Sep 2026), and this button is
      // injected as Add to cart's immediate sibling — inside whatever container the theme put
      // Add to cart in, so it inherits none of the spacing the theme uses between its own
      // buttons. Without this the two render as one merged black block (30 Sep 2026).
      subscribeBtn.style.marginTop = '8px';

      subscribeBtn.addEventListener('click', handleSubscribeButtonClick);

      nativeBtn.insertAdjacentElement('afterend', subscribeBtn);
    }
  });
}

function shouldShowSubscribeButton() {
  // Read the plan from the form, NOT from a checked radio. In the quantity-breaks layout the
  // tier radios also carry class .easymsgsamllradio (manual-subscription.js), so the old
  // selector said "subscription" even for a one-time purchase and replaced Add to cart.
  const isSubscription = !!getSelectedPlanId();
  const isAvailable = isVariantAvailable();
  return (isAvailable && isSubscription && ['RAZORPAY', 'PAYSTACK', 'RAZORPAY_RECURRING'].includes(SUBX.gatewayMode?.toUpperCase()));
}

function isVariantAvailable() {
  const productData = parseJSON(SUBX.SUBS_ELEMENT.dataset.productJsonData, {});
  const variant = productData.variants?.find(v => String(v.id) === String(SUBX.currentVariantId));
  return variant?.available !== false;
}

function toggleSubscribeButton() {
  const shouldShow = shouldShowSubscribeButton();

  ensureSubscribeButtons();

  SUBX.forms.forEach(form => {
    const nativeBtn = form.querySelector('button[type="submit"]:not(.subx__subscribe-btn), input[type="submit"]:not(.subx__subscribe-btn)');
    const subscribeBtn = form.querySelector('.subx__subscribe-btn');
    form.classList.toggle('subx--subscription-active', shouldShow);
    // "Add to cart" now stays visible for a subscription too (29 Sep 2026). It used to be
    // hidden, which is exactly what stopped subscription products ever reaching the cart —
    // and the cart is where multi-product checkout happens. "Subscribe Now" is kept beside
    // it as the one-click path, so the single-product flow every store uses today is
    // untouched; the customer now simply has both.
    if (nativeBtn) {
      nativeBtn.style.display = '';
    }

    if (subscribeBtn) {
      subscribeBtn.style.display = shouldShow ? 'block' : 'none';
    }
  });
}

// ── Cart checkout ────────────────────────────────────────────────────────────
// Reads the Shopify cart, and when it holds at least one subscription line replaces
// the theme's Checkout button with ours, which opens this popup for the whole basket.
//
// A cart of only ordinary products is left alone and goes through Shopify's own
// checkout — better for the merchant (discount codes and everything else still work)
// and there is no contract to create anyway.

// A cart line is a subscription ONLY when it carries a non-empty _eca-selling-plan-id.
// A one-time line still carries "Recurring" (empty) and blank gift fields, so those can
// never be used as the test.
function subxCartLinePlanId(item) {
  const props = (item && item.properties) || {};
  const planId = props['_eca-selling-plan-id'];
  return planId && String(planId).trim() ? String(planId).trim() : '';
}

function subxFetchCart() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .catch(function (err) {
      console.warn('SUBX: could not read the cart', err);
      return null;
    });
}

// Everything the server needs about the cart — what was chosen, never a price.
function subxCartToItems(cart) {
  return ((cart && cart.items) || []).map(function (item) {
    return {
      key: item.key,
      variantId: 'gid://shopify/ProductVariant/' + item.variant_id,
      quantity: Number(item.quantity) || 1,
      sellingPlanId: subxCartLinePlanId(item),
      selectedTierId: ((item.properties || {})['_selected_tier'] || '').toString().trim(),
      properties: item.properties || {},
    };
  });
}

function subxCartHasSubscription(cart) {
  return ((cart && cart.items) || []).some(function (item) { return !!subxCartLinePlanId(item); });
}

// Every place a theme puts a checkout button: the cart page form, the drawer, and the
// plain /checkout links some themes use.
function subxCheckoutButtons() {
  const found = [];
  const selectors = [
    '[name="checkout"]',
    'button[type="submit"][form*="cart"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
  ];
  selectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      console.log(el);
      if (el.closest('.subx__cp-overlay')) return;        // never our own popup
      if (el.classList.contains('subx__cart-btn')) return; // never our own button
      if (found.indexOf(el) === -1) found.push(el);
    });
  });
  return found;
}

function subxEnsureCartButton(nativeBtn) {
  let ours = nativeBtn.parentElement && nativeBtn.parentElement.querySelector('.subx__cart-btn');
  if (ours) return ours;

  ours = nativeBtn.cloneNode(true);
  ours.classList.add('subx__cart-btn');
  ours.removeAttribute('id');
  ours.removeAttribute('name');
  ours.removeAttribute('href');
  ours.removeAttribute('form');
  Array.from(ours.attributes).forEach(function (attr) {
    if (attr.name.startsWith('on:') || attr.name.startsWith('data-')) ours.removeAttribute(attr.name);
  });
  if (ours.tagName === 'BUTTON' || ours.tagName === 'INPUT') ours.type = 'button';
  ours.disabled = false;
  ours.textContent = 'Subscribe & Checkout';
  ours.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    openCartCheckoutPopup();
  });
  nativeBtn.insertAdjacentElement('afterend', ours);
  return ours;
}

// Show ours and hide the theme's — but only when the cart actually holds a subscription.
// The theme's button is only ever HIDDEN, never removed, so if this script fails to load
// the customer can still check out.
function subxSyncCartButtons() {
  // The gateway is only knowable where the product widget exists. On the cart page there
  // is none, so an unknown gateway is treated as "go ahead": the only thing that can put
  // an _eca-selling-plan-id on a cart line is this app, and /pre-order refuses anyway if
  // the shop's gateway cannot take a basket. A KNOWN gateway that cannot is still skipped.
  const gateway = String((SUBX && SUBX.gatewayMode) || '').toUpperCase();
  if (gateway && ['RAZORPAY_RECURRING', 'PAYSTACK'].indexOf(gateway) === -1) return;

  subxFetchCart().then(function (cart) {
    if (!cart) return;
    const takeOver = subxCartHasSubscription(cart);
    SUBX.cart = cart;
    subxCheckoutButtons().forEach(function (nativeBtn) {
      const ours = subxEnsureCartButton(nativeBtn);
      nativeBtn.style.display = takeOver ? 'none' : '';
      ours.style.display = takeOver ? '' : 'none';
    });
  });
}

// The cart drawer is re-rendered on every add/remove/quantity change, which throws our
// button away — so re-apply whenever the DOM under it changes, and after the fetches a
// theme uses to update the cart.
function subxWatchCart() {
  if (SUBX.cartObserver) SUBX.cartObserver.disconnect();
  let pending = null;
  SUBX.cartObserver = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(subxSyncCartButtons, 250);
  });
  SUBX.cartObserver.observe(document.body, { childList: true, subtree: true });

  if (!window.__subxCartFetchPatched) {
    window.__subxCartFetchPatched = true;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
      return originalFetch.apply(this, arguments).then(function (response) {
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(subxSyncCartButtons, 150);
        }
        return response;
      });
    };
  }

  subxSyncCartButtons();
}

// ── What the customer chose, read from the add-to-cart form ──────────────────
// Both widget layouts write these hidden inputs into every add-to-cart form
// (manual-subscription.js — updateSellingPlanInput / updateSelectedTierInput):
//   properties[_eca-selling-plan-id]  the subscription plan ('' = one-time)
//   properties[_selected_tier]        the quantity-break tier, when the product has them
// Reading the form instead of the widget markup means one code path covers the classic
// radio-list layout AND the quantity-breaks layout, where the plan is a <select> and the
// tier radios share the plan radios' class.
function getFormProperty(form, name) {
  const el = form?.querySelector('input[name="properties[' + name + ']"]');
  return (el?.value || '').trim();
}

function getPlanForm(form) {
  if (form) return form;
  const forms = SUBX.forms || [];
  return forms.find(f => getFormProperty(f, '_eca-selling-plan-id')) || forms[0] || null;
}

function getSelectedPlanId(form) {
  return getFormProperty(getPlanForm(form), '_eca-selling-plan-id');
}

function getSelectedTierId(form) {
  return getFormProperty(getPlanForm(form), '_selected_tier');
}

function getSelectedSellingPlan() {
  // Only real plan radios — a tier radio has no data-selling-plan-id.
  return SUBX.SUBS_ELEMENT?.querySelector('.easymsgsamllradio[data-selling-plan-id]:checked');
}

function getQuantity(form) {
  const qtyInput = form?.querySelector('[name="quantity"]');
  return parseInt(qtyInput?.value || '1', 10) || 1;
}

function getProductImage(variant) {
  const rawImage = variant?.featured_image?.src || variant?.image?.src || SUBX.productMeta?.[0]?.featured_image?.src || '';
  return rawImage.startsWith('//') ? `https:${rawImage}` : rawImage;
}

// The classic layout's plan row, so its price, discount badge and prepaid line can be read.
// Searched row by row on purpose. TWO inputs carry data-selling-plan-id: the big
// "Subscribe & Save" radio and each plan row's own radio — and the big one carries the FIRST
// plan's id while sitting outside the rows. A plain document-wide querySelector returns that
// one for plan 1, .closest() then finds no row, and the badge and prepaid line vanish (the
// price only looked right because it falls back to the "from" price, which is plan 1's).
function getSelectedPlanRow(planId) {
  const rows = SUBX.SUBS_ELEMENT ? SUBX.SUBS_ELEMENT.querySelectorAll('.easymsgsubsplanlistcontainerlabCon') : [];
  let checkedRow = null;
  for (let i = 0; i < rows.length; i++) {
    const input = rows[i].querySelector('input[data-selling-plan-id]:checked');
    if (!input) continue;
    if (String(input.dataset.sellingPlanId) === String(planId)) return rows[i];
    if (!checkedRow) checkedRow = rows[i]; // the chosen row, even if its id somehow disagrees
  }
  return checkedRow;
}

function getPlanPrice(planRow) {
  const priceElement = planRow?.querySelector('.easysellingplanallocationprice') || SUBX.SUBS_ELEMENT?.querySelector('.easymsgsubsplanprice');
  return priceElement?.textContent?.trim() || '';
}

function getTotalPrice(priceText, quantity) {
  const match = priceText.replace(/,/g, '').match(/\d+(\.\d+)?/);
  const numericPrice = match ? parseFloat(match[0]) : 0;

  return {
    numeric:numericPrice * quantity,
    formatted:priceText.replace(/\d+(\.\d+)?/, (numericPrice * quantity).toFixed(2))
  };
}

function getDiscountBadge(planRow) {
  return planRow?.querySelector('.easydiscountbadge')?.textContent?.trim() || '';
}

function parseMoneyText(text) {
  const match = String(text || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : 0;
}

// The shop's own money format, e.g. "Rs. {{amount}}" — the same string the widget formats with.
function formatMoneyLikeWidget(amount) {
  const value = (parseFloat(amount) > 0 ? parseFloat(amount) : 0).toFixed(2);
  const format = SUBX.SUBS_ELEMENT?.dataset.moneyFormat || '';
  return format ? format.replace(/\{\{.*?\}\}/g, value) : value;
}

// The line price when NO quantity-break tier applies — the plan discount only, on the whole
// quantity. Mirrors manual-subscription.js updateQuantityBreakPrices(), which is where the tier
// rows get their numbers; only reached when every tier is hidden (a one-time-only offer on a
// subscription), because that layout renders no plan price of its own to read.
function planOnlyPriceText(option, quantity) {
  const container = SUBX.SUBS_ELEMENT?.querySelector('.easymsgqbgroupcontainer');
  if (!container || !option) return '';
  const regularPrice = parseFloat(container.dataset.regularPrice || '0');
  const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
  const discount = parseFloat(option.dataset.discount || '0');
  const discountType = (option.dataset.discountType || 'PERCENTAGE').toUpperCase();

  let unit = regularPrice;
  if (discount > 0) {
    if (discountType === 'PERCENTAGE') unit -= regularPrice * discount / 100;
    else if (discountType === 'FIXED_AMOUNT') unit -= discount * rate;
  }
  if (unit < 0) unit = 0;

  const billingRule = parseFloat(option.dataset.billingRule || '0');
  const delivery = parseFloat(option.dataset.delivery || '0');
  if (option.dataset.isPrepaid === 'true' && billingRule > 0 && delivery > 0) {
    unit *= billingRule / delivery;
  }
  // Round the UNIT before multiplying — the server charges unit × quantity with the unit
  // rounded to the smallest coin, so multiplying the unrounded unit here would show a total
  // a paisa or two away from the charge (23 Sep 2026).
  return formatMoneyLikeWidget(Math.round(unit * 100) / 100 * (parseInt(quantity, 10) || 1));
}

// The plan's name, the price to show, and its discount badge — from whichever layout the
// widget drew.
// In the quantity-breaks layout the plan is a <select> and the checked tier row already
// shows the price for the WHOLE tier (plan discount + tier discount + prepaid, × quantity),
// so `isLineTotal` says "don't multiply this by quantity again".
function getPlanDisplay(sellingPlanId, quantity) {
  const dropdown = SUBX.SUBS_ELEMENT?.querySelector('.easymsgqbplandropdown');
  if (dropdown) {
    const option = dropdown.options[dropdown.selectedIndex];
    // :not(:disabled) matters. A one-time-only tier is HIDDEN when the customer subscribes,
    // but the widget only disables its radio — it leaves it checked. Without this the popup
    // would show the one-time tier's price while the server (rightly) charges plan price only.
    const tierRow = SUBX.SUBS_ELEMENT?.querySelector('.easymsgqbtierradio:checked:not(:disabled)')?.closest('.easymsgqbtieroption');
    return {
      name: option?.dataset.sellingPlanName || (option?.text || '').trim(),
      // No usable tier row = no tier applies to this subscription, and this layout draws no
      // plan price of its own, so work it out the same way the widget would.
      priceText: tierRow
        ? (tierRow.querySelector('.easymsgqbtiertotal')?.textContent?.trim() || '')
        : planOnlyPriceText(option, quantity),
      badge: tierRow?.querySelector('.easymsgqbtierbadge')?.textContent?.trim() || '',
      // "Delivery every 1 Month, prepay 3 Month" — so the customer can see the price covers
      // more than one delivery. Empty for every non-prepaid plan; the popup hides it then.
      prepaidInfo: (option?.dataset.prepaidInfo || '').trim(),
      isLineTotal: true,
    };
  }
  const radio = getSelectedSellingPlan();
  const planRow = getSelectedPlanRow(sellingPlanId);
  return {
    name: radio?.dataset.sellingPlanName || '',
    priceText: getPlanPrice(planRow),
    badge: getDiscountBadge(planRow),
    // The classic layout already prints this line inside the plan row.
    prepaidInfo: (planRow?.querySelector('.easysellingplanprepaidinfo')?.textContent || '').trim(),
    isLineTotal: false,
  };
}

function getSubxPopupData(form) {
  // The form is the source of truth for BOTH layouts (see getSelectedPlanId).
  const sellingPlanId = getSelectedPlanId(form);
  if (!sellingPlanId) {
    console.warn('SUBX: No selling plan selected');
    return null;
  }
  const selectedTierId = getSelectedTierId(form);
  const quantity = getQuantity(form);
  const planDisplay = getPlanDisplay(sellingPlanId, quantity);
  const sellingPlanName = planDisplay.name;
  const pricePerCycle = planDisplay.priceText;
  const discountBadgeText = planDisplay.badge;
  // A tier price is already the line total; a plan price is per item.
  const totalPrice = planDisplay.isLineTotal
    ? { numeric: parseMoneyText(pricePerCycle), formatted: pricePerCycle }
    : getTotalPrice(pricePerCycle, quantity);

  const productData = JSON.parse(SUBX.SUBS_ELEMENT.dataset.productJsonData || '{}');
  const variant = productData.variants?.find( v => String(v.id) === String(SUBX.variantInput.value));
  const rawImg = variant?.featured_image?.src || variant?.image?.src ||  productData?.featured_image ||  productData?.images?.[0] || '';

  const imageUrl = rawImg && rawImg.startsWith('//') ? `https:${rawImg}` : rawImg;

  const productName = productData?.title || '';
  const variantTitle = variant?.title || '';

  return {
    shop: Shopify?.shop || '',
    gateway: SUBX.gatewayMode || '',
    productName: productName || '',
    variantTitle: variantTitle || '',
    imageUrl: imageUrl,
    variantId: `gid://shopify/ProductVariant/${SUBX.currentVariantId}`,
    variantNumericId: SUBX.currentVariantId,
    sellingPlanId,
    sellingPlanName,
    // "Delivery every 1 Month, prepay 3 Month", or '' when the plan is not prepaid.
    prepaidInfo: planDisplay.prepaidInfo || '',
    // WHICH quantity-break tier is picked — the server looks it up again and works out the
    // money itself, so this is only ever an id, never a discount and never a price.
    selectedTierId,
    pricePerCycle,
    // true when pricePerCycle is already the price for the whole quantity (a tier row).
    priceIsLineTotal: planDisplay.isLineTotal,
    totalPricePerCycle: totalPrice.formatted,
    totalPriceNumeric: totalPrice.numeric,
    discountBadgeText,
    quantity,
    customerLoggedIn: SUBX.SUBS_ELEMENT.dataset.customerLoggedIn === 'true',
    customerEmail: SUBX.SUBS_ELEMENT.dataset.customerEmail || '',
    customerFirstName: SUBX.SUBS_ELEMENT.dataset.customerFirstName || '',
    customerLastName: SUBX.SUBS_ELEMENT.dataset.customerLastName || '',
    customerPhone: SUBX.SUBS_ELEMENT.dataset.customerPhone || '',
    customerAddress: parseJSON(SUBX.SUBS_ELEMENT.dataset.customerDefaultAddress),
    loginUrl: SUBX.SUBS_ELEMENT.dataset.loginUrl || '/account/login'
  };
}

// Opens the popup for the whole cart. The cart tells us WHAT was chosen; the server
// prices it, because /cart.js can never show a prepaid total — a Shopify discount
// function can only reduce a price, never multiply it up. So a prepaid line reads as
// one delivery in the cart while the real charge covers several.
function openCartCheckoutPopup() {
  const root = SUBX.SUBS_ELEMENT || document.querySelector('.easymanualsubsection');
  const dataset = (root && root.dataset) || {};

  subxFetchCart().then(function (cart) {
    if (!cart || !cart.items || !cart.items.length) {
      console.warn('SUBX: cart is empty');
      return;
    }
    if (!subxCartHasSubscription(cart)) {
      // Nothing to subscribe to — let Shopify's own checkout handle it.
      window.location.href = '/checkout';
      return;
    }

    openCheckoutPopup({
      isCart: true,
      shop: (window.Shopify && window.Shopify.shop) || '',
      gateway: SUBX.gatewayMode || '',
      items: subxCartToItems(cart),
      cart: cart,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cart.currency || '',
      currencyRate: (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1,
      customerLoggedIn: dataset.customerLoggedIn === 'true',
      customerEmail: dataset.customerEmail || '',
      customerFirstName: dataset.customerFirstName || '',
      customerLastName: dataset.customerLastName || '',
      customerPhone: dataset.customerPhone || '',
      customerAddress: parseJSON(dataset.customerDefaultAddress),
      loginUrl: dataset.loginUrl || '/account/login',
    });
  });
}

function handleSubscribeButtonClick(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const form = event.currentTarget.closest('form');

  if (!form) return;

  const SubxPopupData = getSubxPopupData(form);
  openCheckoutPopup(SubxPopupData);
}

function initSUBX() {
  // No product widget on this page — the cart page and the cart drawer have none. Everything
  // below reads SUBX.SUBS_ELEMENT and SUBX.forms, which refreshSUBX only fills when it found
  // one, so carrying on threw a TypeError inside toggleSubscribeButton. That killed bootSUBX
  // before it reached initSUBXCart, which is why /cart never got the Subscribe & Checkout
  // button while the drawer (opened from a product page, where this all succeeds) did
  // (30 Sep 2026).
  if (!refreshSUBX()) return;
  toggleSubscribeButton();

  setupPurchaseOptionObserver();
  setupSellingPlanObserver();
  setupVariantObserver();
  setupWidgetObserver();
  subxWatchCart();
}

// The cart page and the cart drawer have no product widget on them, so refreshSUBX()
// finds nothing and initSUBX() above never runs there. The cart button still has to be
// taken over, so start it from the gateway mode alone.
function initSUBXCart() {
  if (SUBX.SUBS_ELEMENT) return;            // a product page — initSUBX already did it
  const root = document.querySelector('.easymanualsubsection');
  window.SUBX.gatewayMode = (root && root.dataset.gatewayMode)
    || window.SUBX_GATEWAY_MODE
    || '';
  // No gateway here is normal — the cart page carries no product widget. Start anyway;
  // subxSyncCartButtons only acts when the cart really holds a subscription line.
  subxWatchCart();
}

function bootSUBX() {
  initSUBX();
  initSUBXCart();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSUBX);
} else {
  bootSUBX();
}

// ── After Back: make the page match what the widget shows ────────────────────
// Pressing Back (e.g. from the customer account page the popup sends the customer to after
// paying) reloads this product page, and the browser then quietly puts back the customer's
// last choice in the widget — the "Subscribe & save" radio, a plan row, the quantity-breaks
// plan dropdown and tier — WITHOUT firing `change`. The widget writes the chosen plan into the
// form's hidden properties[_eca-selling-plan-id] field only on `change`, or once when it first
// draws, which is before the browser restores anything. So the radio said "Subscribe" while
// that field was still empty, everything here (which reads the field) decided "one-time", and
// Add to cart showed for what looked like a subscription.

// What the widget SHOWS as chosen: the plan ('' = one-time) and the control that says so.
function getShownSelection() {
  const root = SUBX.SUBS_ELEMENT;
  if (!root) return null;
  // Quantity-breaks layout: the dropdown holds the plan (its handler also sets the checkbox).
  const dropdown = root.querySelector('.easymsgqbplandropdown');
  if (dropdown) {
    const option = dropdown.options[dropdown.selectedIndex];
    const isOneTime = !option?.value || option?.dataset.isOneTime === 'true';
    return { planId: isOneTime ? '' : option.value, control: dropdown };
  }
  // Classic layout, read the way the widget's own handleChange does: "Regular purchase" wins,
  // then a checked plan row, then "Subscribe & save" alone (the widget then picks plan 1).
  const oneTime = root.querySelector('input[id^="one_time_purchase_option_"]:checked');
  const subscribe = root.querySelector('.easymsgradiobig[id^="selling_plan_purchase_option_"]:checked');
  const planRow = root.querySelector('.easymsgsamllradio[data-selling-plan-id]:checked');
  if (oneTime && !subscribe) return { planId: '', control: oneTime };
  if (planRow) return { planId: planRow.dataset.sellingPlanId || '', control: planRow };
  if (subscribe) {
    const firstRow = root.querySelector('.easymsgsamllradio[data-selling-plan-id]');
    return { planId: (firstRow || subscribe).dataset.sellingPlanId || '', control: subscribe };
  }
  return null;
}

// Replays `change` on whatever the widget shows, but only where it disagrees with the form,
// so the widget rewrites the hidden fields and the right button shows. On a normal page load
// everything already agrees and this does nothing.
function resyncShownSelection() {
  if (!refreshSUBX()) return;
  const fire = (el) => el.dispatchEvent(new Event('change', { bubbles: true }));
  const shown = getShownSelection();
  if (shown && shown.planId !== getSelectedPlanId()) fire(shown.control);
  // Quantity breaks: the tier also sets the cart quantity (and _selected_tier). Read it after
  // the plan replay — switching plan can move the pick to another tier.
  const tier = SUBX.SUBS_ELEMENT.querySelector('.easymsgqbtierradio:checked:not(:disabled)');
  if (tier && String(getQuantity(getPlanForm())) !== String(tier.value)) fire(tier);
  // The quantity-breaks listeners above react a tick later; settle the buttons after them.
  setTimeout(() => { if (refreshSUBX()) toggleSubscribeButton(); }, 0);
}

// `pageshow` fires after the browser has restored the form — on a normal load and on a
// back/forward-cache restore. A cache restore shows the page exactly as it was left, so the
// popup may still be open with Pay stuck on "Processing…": start clean.
window.addEventListener('pageshow', (event) => {
  if (event.persisted && window.SUBXCheckoutPopup) window.SUBXCheckoutPopup.close();
  resyncShownSelection();
});
// This script loaded after `pageshow` had already fired — sync now instead.
if (document.readyState === 'complete') setTimeout(resyncShownSelection, 0);

// ── Add to cart carries the chosen plan ──────────────────────────────────────
// Before a subscription line is added to the cart, make the hidden plan field agree with what
// the widget SHOWS. After Back, the browser restores the customer's choice without firing
// `change`, so the widget never writes it into properties[_eca-selling-plan-id] and the line
// would go in as a one-time purchase. Capture phase, so this runs before the theme's own
// submit handler.
//
// This used to also preventDefault() and open the popup instead, from when Add to cart was
// hidden for a subscription. That is gone as of 29 Sep 2026: Add to cart is now how a
// multi-product basket gets built, so the submit has to go through. "Subscribe Now" is still
// the one-click path for a single product. The cart button takeover (subxSyncCartButtons)
// keeps a subscription cart out of Shopify's own checkout.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!refreshSUBX() || !SUBX.forms.includes(form)) return;
  resyncShownSelection();
}, true);

window.SUBX.popup = {instance: null};

function initPopup() {
  if (window.SUBX.popup.instance) return;
  window.SUBX.popup.instance = window.SUBXCheckoutPopup;
}

function openCheckoutPopup(data) {
  initPopup();

  if (!window.SUBX.popup.instance) {
    console.warn('SUBX Popup not available');
    return;
  }

  window.SUBX.popup.instance.open(data);
}

(function () {
  'use strict';
  var SUBX_APP_URL = 'https://apps.easysubscription.io';
  // Shop-specific: the direct link to this store's "Subscriptions" page in the new
  // customer accounts UI (Shopify assigns this ID per shop at install time, with no
  // way to compute it — copy it from the account page's address bar for each store
  // this file gets uploaded to). Falls back to the generic /account root if left blank.
  var SUBX_ACCOUNT_SUBSCRIPTIONS_URL = 'https://shopify.com/28509569084/account/pages/d8b7e920-2e71-4d67-854d-77ce0b6ef737';

  // Lazily loads Razorpay's Checkout.js (once) and resolves with window.Razorpay.
  // Used so the mandate/first-charge payment happens in-page instead of a full-page
  // redirect to Razorpay's hosted short_url — that hosted page has no way to send the
  // customer back to the store afterwards, which is the whole reason for this change.
  var razorpayScriptPromise = null;
  function loadRazorpayCheckout() {
    if (window.Razorpay) return Promise.resolve(window.Razorpay);
    if (razorpayScriptPromise) return razorpayScriptPromise;
    razorpayScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = function () {
        if (window.Razorpay) resolve(window.Razorpay);
        else reject(new Error('Razorpay Checkout failed to initialize'));
      };
      script.onerror = function () {
        razorpayScriptPromise = null;
        reject(new Error('Failed to load Razorpay Checkout script'));
      };
      document.head.appendChild(script);
    });
    return razorpayScriptPromise;
  }

  var POPUP_CSS = [
    '#subx__cp-overlay{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);',
    'display:flex;align-items:center;justify-content:center;padding:12px;box-sizing:border-box;',
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;overscroll-behavior:none;}',
    '#subx__cp-overlay[hidden]{display:none!important;}',
    
    '#subx__cp-overlay,#subx__cp-overlay *{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    // A universal selector (the rule above) matches real elements only — it does not reach
    // pseudo-elements like ::placeholder, which need their own explicit selector. Input
    // placeholder text ("First name", "House / Flat / Street", etc.) is rendered through
    // ::placeholder, so a theme's own input::placeholder rule (very common — many themes
    // style placeholder text with a wide letter-spacing or different font for a muted look)
    // still leaks through there even though every other piece of popup text is already fixed.
    '#subx__cp-overlay input::placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay input::-webkit-input-placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay input:-ms-input-placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',

    '.subx__cp-modal{background:#fff;border-radius:14px;width:100%;max-width:940px;max-height:92vh;',
    'overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.22);display:flex;flex-direction:column;overscroll-behavior:contain;}',
    '.subx__cp-modal::-webkit-scrollbar{width:4px;}',
    '.subx__cp-modal::-webkit-scrollbar-thumb{background:#ddd;border-radius:4px;}',

    '.subx__cp-header{display:flex;align-items:center;justify-content:space-between;',
    'padding:18px 24px 14px;border-bottom:1px solid #f0f0f0;',
    'position:sticky;top:0;background:#fff;z-index:10;}',
    '.subx__cp-header h2{margin:0;font-size:17px;font-weight:700;color:#111;}',
    '.subx__cp-close{background:#f4f4f4;border:none;width:30px;height:30px;border-radius:50%;',
    'font-size:16px;cursor:pointer;color:#555;padding:0;display:flex;align-items:center;justify-content:center;}',
    '.subx__cp-close:hover{background:#e8e8e8;}',

    '.subx__cp-grid{display:grid;grid-template-columns:1.15fr .85fr;grid-template-areas:"form summary";}',
    '.subx__cp-col-form{grid-area:form;padding:20px 24px;}',
    
    '.subx__cp-col-summary{grid-area:summary;padding:20px 24px;background:#fafafa;border-left:1px solid #f0f0f0;',
    'align-self:start;position:sticky;top:0;}',
    '#subx__cp-overlay .subx__cp-col-title{margin:0 0 16px;font-size:13px;font-weight:700;',
    'text-transform:uppercase;letter-spacing:.6px!important;color:#333;}',

    '.subx__cp-section{padding:14px 0;border-bottom:1px solid #f0f0f0;}',
    '.subx__cp-section:first-child{padding-top:0;}',
    '.subx__cp-section:last-child{border-bottom:none;}',
    '.subx__cp-section-title{margin:0 0 12px;font-size:13px;font-weight:700;color:#333;}',
    '.subx__cp-row{margin-bottom:10px;}.subx__cp-row:last-child{margin-bottom:0;}',
    '.subx__cp-row-2{display:grid;grid-template-columns:1fr 1fr;gap:10px;}',
    '.subx__cp-field label{display:block;font-size:12px;font-weight:600;color:#444;margin-bottom:5px;}',
    '.subx__cp-field input,.subx__cp-field select{width:100%;box-sizing:border-box;border:1.5px solid #e0e0e0;',
    'border-radius:8px;padding:10px 13px;font-size:14px;color:#111;outline:none;background:#fff;',
    'font-family:inherit;transition:border-color .15s,box-shadow .15s;}',
    '.subx__cp-field input:focus,.subx__cp-field select:focus{border-color:#1a7c3e;box-shadow:0 0 0 3px rgba(26,124,62,.1);}',
    '.subx__cp-field input.subx__cp-invalid,.subx__cp-field select.subx__cp-invalid{border-color:#d93025;background:#fff8f8;}',
    '.subx__cp-field-err{font-size:11px;color:#d93025;margin-top:3px;display:none;}',
    '.subx__cp-field-err.subx__cp-show{display:block;}',
    '.subx__cp-row-checkbox{margin-bottom:18px!important;}',
    '.subx__cp-login-banner{background:#eef6fd;border:1px solid #cfe6fa;border-radius:10px;',
    'padding:14px 16px;margin:4px 0 14px;}',
    '.subx__cp-login-title{font-size:14px;font-weight:700;color:#111;margin:0 0 4px;}',
    '.subx__cp-login-desc{font-size:12px;color:#666;margin:0 0 12px;line-height:1.5;}',
    '.subx__cp-login-btn{display:inline-block;background:#000;color:#fff;padding:9px 18px;',
    'border-radius:7px;font-size:13px;font-weight:700;text-decoration:none;}',
    '.subx__cp-login-btn:hover{background:#222;}',
    '.subx__cp-checkbox-label{display:flex;align-items:center;gap:9px;font-size:13px;color:#444;cursor:pointer;}',
    '.subx__cp-checkbox-label input{width:18px;height:18px;margin:0;cursor:pointer;flex-shrink:0;',
    'accent-color:#000;border-radius:4px;}',

    '.subx__cp-sum-product{display:flex;gap:12px;align-items:center;margin-bottom:14px;}',
    '#subx__cp-img-wrap{width:54px;height:54px;border-radius:8px;flex-shrink:0;',
    'display:flex;align-items:center;justify-content:center;background:#eee;font-size:20px;overflow:hidden;}',
    '#subx__cp-img-wrap img{width:54px;height:54px;border-radius:8px;object-fit:cover;border:1px solid #eee;}',
    '#subx__cp-product-name{font-size:14px;font-weight:700;color:#111;margin:0 0 3px;}',
    '#subx__cp-plan-name{font-size:12px;color:#666;margin:0;}',
    '#subx__cp-plan-prepaid{font-size:11px;color:#888;margin:3px 0 0;line-height:1.3;}',
    '.subx__cp-sum-divider{border-top:1px solid #e6e6e6;margin:14px 0;}',
    '.subx__cp-sum-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}',
    '.subx__cp-sum-row:last-child{margin-bottom:0;}',
    '.subx__cp-sum-label{font-size:13px;color:#666;}',
    '.subx__cp-sum-value{font-size:13px;color:#111;font-weight:600;}',
    '.subx__cp-shipping-note{font-size:12px;color:#888;font-weight:500;font-style:italic;',
    'text-align:right;max-width:60%;}',
    '.subx__cp-sum-total .subx__cp-sum-label{font-size:14px;color:#111;font-weight:700;}',
    '.subx__cp-sum-total .subx__cp-sum-value{font-size:16px;color:#111;font-weight:800;}',
    '#subx__cp-variant-display{display:block;width:100%;box-sizing:border-box;border:1.5px solid #e6e6e6;',
    'border-radius:8px;padding:9px 12px;font-size:13px;color:#333;background:#fff;}',

    // Every visual property here gets !important, not just font-family/letter-spacing —
    // border-radius specifically was found leaking on a live store (some themes apply
    // !important to their own button radius/border/background for sitewide CTA styling,
    // which beats a plain, non-!important declaration regardless of our selector's
    // specificity). Hardening the whole rule avoids finding these one property at a time.
    '#subx__cp-overlay .subx__cp-btn-submit{width:100%!important;padding:14px 20px!important;border:none!important;border-radius:9px!important;margin:16px 0!important;',
    'background:#000!important;color:#fff!important;font-size:14px!important;font-weight:700!important;cursor:pointer!important;',
    'letter-spacing:.4px!important;text-transform:uppercase!important;transition:background .15s!important;}',
    '#subx__cp-overlay .subx__cp-btn-submit:hover:not(:disabled){background:#222!important;}',
    '#subx__cp-overlay .subx__cp-btn-submit:disabled{opacity:.6!important;cursor:not-allowed!important;}',

    '.subx__cp-info-box{border:1px solid #e3def7;background:#f8f6ff;border-radius:10px;',
    'padding:12px 14px;margin-bottom:12px;}',
    '.subx__cp-info-box p{margin:0;}',
    '.subx__cp-info-title{font-size:13px;font-weight:700;color:#111;margin-bottom:4px;}',
    '.subx__cp-info-body{font-size:12px;color:#666;line-height:1.5;}',
    '.subx__cp-info-divider{border-top:1px solid #e3def7;margin:10px 0;}',

    '.subx__cp-global-err{font-size:13px;color:#d93025;margin:0 0 10px;',
    'display:none;padding:8px 12px;background:#fff0f0;border-radius:6px;}',
    '.subx__cp-global-err.subx__cp-show{display:block;}',

    // Shipping rate picker (summary column).
    '#subx__cp-shipping-options{margin:10px 0 4px;}',
    '.subx__cp-ship-label{display:block;font-size:12px;font-weight:600;color:#444;margin-bottom:6px;}',
    // One option per row, full width. Hardened the same way as the submit button: a theme
    // whose own <label> rule wins (an id-scoped selector, or !important) turns these rows
    // into shrink-to-fit inline boxes that sit side by side — seen on a live store.
    '#subx__cp-overlay .subx__cp-ship-rate{display:flex!important;align-items:center!important;gap:8px!important;',
    'padding:9px 10px!important;border:1px solid #e5e5e5!important;border-radius:7px!important;',
    'margin:0 0 6px!important;width:100%!important;box-sizing:border-box!important;float:none!important;',
    'cursor:pointer!important;font-size:13px!important;font-weight:400!important;text-transform:none!important;',
    'color:#111!important;background:#fff!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate input{margin:0!important;flex:0 0 auto!important;',
    'width:16px!important;height:16px!important;accent-color:#000!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-title{flex:1 1 auto!important;min-width:0!important;text-align:left!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-sub{display:block!important;font-size:11px!important;color:#777!important;',
    'font-weight:500!important;margin-top:2px!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-price{flex:0 0 auto!important;font-weight:700!important;white-space:nowrap!important;}',
    // Ship / Pickup tabs, like Shopify checkout. !important: themes style every <button>.
    '.subx__cp-ship-tabs{display:flex;gap:8px;margin:0 0 8px;}',
    '#subx__cp-overlay .subx__cp-ship-tab{flex:1 1 0!important;width:auto!important;margin:0!important;padding:9px 10px!important;',
    'border:1px solid #e5e5e5!important;border-radius:7px!important;background:#fff!important;color:#111!important;',
    'font-size:13px!important;font-weight:600!important;cursor:pointer!important;text-transform:none!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay .subx__cp-ship-tab.subx__cp-active{border-color:#000!important;box-shadow:inset 0 0 0 1px #000!important;}',
    '.subx__cp-ship-status{font-size:12px;color:#888;font-style:italic;margin:4px 0 8px;text-align:right;}',
    '.subx__cp-ship-status.subx__cp-ship-error{color:#d93025;font-style:normal;}',
    // !important for the same reason as the submit button: themes style every <button>.
    '#subx__cp-overlay .subx__cp-ship-retry{background:none!important;border:none!important;padding:0!important;margin:0!important;',
    'width:auto!important;color:#1a5fb4!important;text-decoration:underline!important;cursor:pointer!important;',
    'font-size:12px!important;font-weight:600!important;text-transform:none!important;}',
    '.subx__cp-sum-row.subx__cp-payment-container{flex-direction:column;align-items: flex-start;}.subx__cp-payment-label{font-size:14px;color:#111;font-weight:700;}',
    '.subx__cp-payment-option{display:flex;align-items:center;gap:5px;margin:0;width:100%;box-sizing:border-box;float:none;cursor:pointer;font-size:13px;font-weight:400;text-transform:none;color:#111;cursor:pointer;width:auto;}',
    '#subx__cp-payment-options{display:flex;align-items:flex-start;justify-content:flex-start;width:100%;margin-top:5px;gap:15px;}',
    '.subx__cp-payment-option input[type="radio"]{margin:0!important;flex:0 0 auto!important;width:16px!important;height:16px!important;accent-color:#000!important;cursor:pointer;}',
    '#subx__cp-overlay .subx__cp-method-badge{display:inline-block!important;margin-left:6px!important;padding:2px 7px!important;',
    'border-radius:10px!important;background:#e7f4ec!important;color:#1a7c3e!important;border:1px solid #cfe8da!important;',
    'font-size:10px!important;font-weight:700!important;line-height:1.4!important;text-transform:uppercase!important;',
    'letter-spacing:.3px!important;white-space:nowrap!important;vertical-align:middle!important;}',

    '@media(max-width:720px){',
    '.subx__cp-grid{grid-template-columns:1fr;grid-template-areas:"summary" "form";}',
    // Stacked single-column layout here — pinning the summary would just eat scroll space on
    // a small screen instead of helping, so undo the sticky behavior from the desktop rule.
    '.subx__cp-col-summary{border-left:none;border-bottom:1px solid #f0f0f0;position:static;}',
    '.subx__cp-row-2{grid-template-columns:1fr;}',
    '.subx__cp-col-form,.subx__cp-col-summary{padding:16px;}',
    '.subx__cp-header{padding-left:16px;padding-right:16px;}',
    '}'
    // There used to be a rule here hiding the theme's Add to cart whenever a plan was
    // chosen (.subx--subscription-active button[type=submit]). Removed 29 Sep 2026: it
    // carried !important, so it beat toggleSubscribeButton's style.display = '' and kept
    // the button hidden even after that function stopped hiding it. With no Add to cart a
    // subscription product can never reach the cart, and the cart is where multi-product
    // checkout happens. Both buttons now show: Add to cart builds a basket, Subscribe Now
    // is still the one-click path. The class is still set on the form as a styling hook.
  ].join('');

  // ── HTML injected once into <body> ────────────────────────────────────────

  var POPUP_HTML = '<div id="subx__cp-overlay" hidden>' +
    '<div class="subx__cp-modal" role="dialog" aria-modal="true" aria-labelledby="subx__cp-title">' +

    '<div class="subx__cp-header">' +
    '<h2 id="subx__cp-title">Checkout Details</h2>' +
    '<button class="subx__cp-close" type="button" aria-label="Close">&#x2715;</button>' +
    '</div>' +

    '<div class="subx__cp-grid">' +

    // ── Left column: Checkout Details ──
    '<div class="subx__cp-col-form">' +

    '<div class="subx__cp-section">' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-email">Email *</label>' +
    '<input id="subx__cp-email" type="email" placeholder="Enter your email address" autocomplete="email"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-email-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-login-banner" id="subx__cp-login-banner" style="display:none;">' +
    '<p class="subx__cp-login-title">Login to use saved addresses</p>' +
    '<p class="subx__cp-login-desc">Sign in to your account to quickly select from your saved delivery addresses and enjoy a faster checkout experience.</p>' +
    '<a href="/account/login" id="subx__cp-login-btn" class="subx__cp-login-btn">Login</a>' +
    '</div>' +
    '</div>' +

    '<div class="subx__cp-section">' +
    '<p class="subx__cp-section-title">Shipping Information</p>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-fname">First Name *</label>' +
    '<input id="subx__cp-fname" type="text" placeholder="First name" autocomplete="given-name"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-fname-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-lname">Last Name *</label>' +
    '<input id="subx__cp-lname" type="text" placeholder="Last name" autocomplete="family-name"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-lname-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-addr1">Address Line 1 *</label>' +
    '<input id="subx__cp-addr1" type="text" placeholder="House / Flat / Street" autocomplete="address-line1"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-addr1-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-addr2">Address Line 2 (Optional)</label>' +
    '<input id="subx__cp-addr2" type="text" placeholder="Area / Landmark (optional)" autocomplete="address-line2"/>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-country">Country *</label>' +
    '<select id="subx__cp-country" autocomplete="country-name"></select>' +
    '<span class="subx__cp-field-err" id="subx__cp-country-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-province-select">State / Province *</label>' +
    '<select id="subx__cp-province-select" autocomplete="address-level1"></select>' +
    '<input id="subx__cp-province-text" type="text" placeholder="State / Province" autocomplete="address-level1" style="display:none;"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-province-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-city">City *</label>' +
    '<input id="subx__cp-city" type="text" placeholder="City" autocomplete="address-level2"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-city-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-zip">ZIP / Postal *</label>' +
    '<input id="subx__cp-zip" type="text" placeholder="400001" autocomplete="postal-code"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-zip-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-phone">Phone Number *</label>' +
    '<input id="subx__cp-phone" type="tel" placeholder="9876543210" autocomplete="tel" maxlength="14"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-phone-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-checkbox">' +
    '<label class="subx__cp-checkbox-label" for="subx__cp-billing-same">' +
    '<input type="checkbox" id="subx__cp-billing-same" checked/>' +
    '<span>Billing address same as shipping</span>' +
    '</label>' +
    '</div>' +
    '</div>' +

    '<div class="subx__cp-section" id="subx__cp-billing-section" style="display:none;">' +
    '<p class="subx__cp-section-title">Billing Information</p>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-billing-addr1">Address Line 1 *</label>' +
    '<input id="subx__cp-billing-addr1" type="text" placeholder="House / Flat / Street" autocomplete="billing address-line1"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-addr1-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-billing-addr2">Address Line 2 (Optional)</label>' +
    '<input id="subx__cp-billing-addr2" type="text" placeholder="Area / Landmark (optional)" autocomplete="billing address-line2"/>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-country">Country *</label>' +
    '<select id="subx__cp-billing-country" autocomplete="billing country-name"></select>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-country-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-province-select">State / Province *</label>' +
    '<select id="subx__cp-billing-province-select" autocomplete="billing address-level1"></select>' +
    '<input id="subx__cp-billing-province-text" type="text" placeholder="State / Province" autocomplete="billing address-level1" style="display:none;"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-province-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-city">City *</label>' +
    '<input id="subx__cp-billing-city" type="text" placeholder="City" autocomplete="billing address-level2"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-city-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-zip">ZIP / Postal *</label>' +
    '<input id="subx__cp-billing-zip" type="text" placeholder="400001" autocomplete="billing postal-code"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-zip-err"></span></div>' +
    '</div>' +
    '</div>' +

    '</div>' + // end .subx__cp-col-form

    // ── Right column: Subscription Summary ──
    '<div class="subx__cp-col-summary">' +
    '<p class="subx__cp-col-title">Subscription Summary</p>' +

    '<div class="subx__cp-sum-product">' +
    '<div id="subx__cp-img-wrap">&#128717;</div>' +
    '<div>' +
    '<p id="subx__cp-product-name"></p>' +
    '<p id="subx__cp-plan-name"></p>' +
    '<p id="subx__cp-plan-prepaid" style="display:none;"></p>' +
    '</div></div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label>Variant</label>' +
    '<span id="subx__cp-variant-display"></span>' +
    '</div></div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-sum-row">' +
    '<span class="subx__cp-sum-label">Plan Price</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-sum-plan-price"></span>' +
    '</div>' +
    '<div class="subx__cp-sum-row">' +
    '<span class="subx__cp-sum-label" id="subx__cp-shipping-label">Shipping</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-shipping-price">—</span>' +
    '</div>' +
    '<p id="subx__cp-shipping-status" class="subx__cp-ship-status" style="display:none;"></p>' +
    '<div id="subx__cp-shipping-options" style="display:none;">' +
    '<span class="subx__cp-ship-label" id="subx__cp-shipping-options-label">Shipping Method</span>' +
    '<div id="subx__cp-ship-tabs" class="subx__cp-ship-tabs" style="display:none;">' +
    '<button type="button" class="subx__cp-ship-tab" data-mode="SHIP" aria-pressed="true">Ship</button>' +
    '<button type="button" class="subx__cp-ship-tab" data-mode="PICKUP" aria-pressed="false">Pickup</button>' +
    '</div>' +
    '<div id="subx__cp-shipping-list"></div>' +
    '</div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-sum-row subx__cp-sum-total">' +
    '<span class="subx__cp-sum-label">Subscription Total</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-sum-total"></span>' +
    '</div>' +

    // Hidden until the server says which methods this shop offers — see
    // _loadPaymentMethods. UPI is never shown on trust.
    '<div class="subx__cp-sum-row subx__cp-payment-container" id="subx__cp-payment-row" style="display:none;">' +
    '<span class="subx__cp-payment-label">Payment method:</span>' +
    '<div id="subx__cp-payment-options">'+
    '<label class="subx__cp-payment-option" id="subx__cp-method-card" for="subx__payement-option-card">'+
    '<input type="radio" name="payment_options" value="card" checked="" id="subx__payement-option-card">'+
    '<span class="subx__cp-ship-rate-title">Card<span class="subx__cp-method-badge">Recommended</span></span>'+
    '</label>'+
    '<label class="subx__cp-payment-option" id="subx__cp-method-upi" for="subx__payement-option-upi" style="display:none;">'+
    '<input type="radio" name="payment_options" value="upi" id="subx__payement-option-upi">'+
    '<span class="subx__cp-ship-rate-title">UPI</span>'+
    '</label></div>'+
    '</div>' +

    '<p id="subx__cp-global-err" class="subx__cp-global-err"></p>' +
    '<button type="button" id="subx__cp-submit" class="subx__cp-btn-submit">Proceed to Payment</button>' +

    '<div class="subx__cp-info-box">' +
    '<p class="subx__cp-info-title" id="subx__cp-info-discount-title">Subscribe once and enjoy ongoing savings on future orders</p>' +
    '<p class="subx__cp-info-body">Automatic deliveries at your chosen interval. Easy to manage, cancel anytime.</p>' +
    '<div class="subx__cp-info-divider"></div>' +
    '<p class="subx__cp-info-title">How to Subscribe</p>' +
    '<p class="subx__cp-info-body">Enable a UPI mandate to automate payments for recurring orders.</p>' +
    '</div>' +

    '</div>' + // end .subx__cp-col-summary

    '</div>' + // end .subx__cp-grid

    '</div></div>';

  // ── Country / State static lists ──────────────────────────────────────────
  // State select is shown for India only; other countries fall back to a free-text input.

  // Only the countries our gateways actually serve, so a customer finds theirs at once:
  // India (Razorpay) and the five countries a Paystack account can be opened in. It was a
  // 51-country list until 23 Sep 2026, which buried the two that are really used. Add a
  // country here when a store in it goes live — and give it a code in COUNTRY_CODES
  // (deliveryOptions.js), or Shopify will drop its own delivery method from the order.
  var COUNTRY_LIST = ['India', 'South Africa', 'Nigeria', 'Ghana', 'Kenya', 'Egypt'];

  // Which country the form starts on. Shopify sets `Shopify.country` to the market the
  // storefront is being viewed in, so a South African store opens on South Africa instead of
  // making every customer change it. Unknown or missing (no Markets) → India, as before.
  var COUNTRY_BY_CODE = { IN: 'India', ZA: 'South Africa', NG: 'Nigeria', GH: 'Ghana', KE: 'Kenya', EG: 'Egypt' };
  var DEFAULT_COUNTRY = COUNTRY_BY_CODE[String((window.Shopify || {}).country || '').toUpperCase()] || 'India';

  var INDIA_STATES = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat',
    'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
    'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep',
    'Puducherry'];

  // South Africa's nine provinces, spelled exactly as Shopify spells them — a typo here, or a
  // province typed by hand, can make Shopify return no shipping rates for a good address.
  var SOUTH_AFRICA_PROVINCES = ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
    'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'];

  // A country listed here gets a dropdown; every other country keeps the free-text box.
  var STATES_BY_COUNTRY = { 'India': INDIA_STATES, 'South Africa': SOUTH_AFRICA_PROVINCES };

  // ── Phone number ──────────────────────────────────────────────────────────
  // Shopify checks the phone against the delivery country and refuses to create the
  // ORDER AT ALL when it doesn't match — it answers {"field":["phone"],"message":"Phone
  // is invalid"} and no order and no draft order are made, after the customer has paid.
  // This store ships only to India, so every number is reduced to its 10 digits and sent
  // as +91XXXXXXXXXX. Returns '' when it cannot be read as an Indian mobile, and the
  // validation below then asks the customer to correct it BEFORE any money moves.
  function subxNormaliseIndianPhone(raw) {
    var digits = String(raw || '').replace(/\D/g, '');     // drop + ( ) - and spaces
    if (digits.length === 13 && digits.indexOf('091') === 0) digits = digits.slice(3);
    else if (digits.length === 12 && digits.indexOf('91') === 0) digits = digits.slice(2);
    else if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
    // Indian mobile numbers are 10 digits and start 6, 7, 8 or 9.
    if (digits.length !== 10 || '6789'.indexOf(digits.charAt(0)) === -1) return '';
    return '+91' + digits;
  }

  // ── Popup class ───────────────────────────────────────────────────────────

  function SubxCheckoutPopup() {
    this._options = {};
    this._overlay = null;
    this._ready = false;
    var self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { self._init(); });
    } else {
      this._init();
    }
  }

  SubxCheckoutPopup.prototype._init = function () {
    if (this._ready) return;
    // Inject CSS
    if (!document.getElementById('subx__cp-styles')) {
      var s = document.createElement('style');
      s.id = 'subx__cp-styles';
      s.textContent = POPUP_CSS;
      document.head.appendChild(s);
    }
    // Inject HTML
    if (!document.getElementById('subx__cp-overlay')) {
      var wrap = document.createElement('div');
      wrap.innerHTML = POPUP_HTML;
      document.body.appendChild(wrap.firstElementChild);
    }
    this._overlay = document.getElementById('subx__cp-overlay');
    this._guardFocus();
    this._populateLocationSelects();
    this._bindEvents();
    this._ready = true;
  };

  // ── Let the customer actually type in our fields ──────────────────────────
  // Themes trap focus while a drawer or modal is open: they listen for `focusin` and, when
  // focus lands outside the container they are guarding, send it straight back. This popup
  // is appended to <body>, outside any of those containers, so every click into an input was
  // undone a moment later and nothing could be typed — the radios still worked, because a
  // click toggles them without needing to hold focus (found 29 Sep 2026, multicarbrand's
  // assets/focus.js).
  //
  // The theme registers on `document` in the CAPTURE phase, so stopping the event at our
  // overlay would be too late — capture runs from the root down. `window` is one step above
  // `document` on that path, so a capture listener here always runs first, whichever script
  // loaded first. Only events that start inside our overlay are stopped; everything else
  // reaches the theme untouched, and the guard does nothing at all while we are closed.
  //
  // `keydown` is deliberately NOT guarded: the theme's keydown half only handles Tab
  // cycling, and swallowing keydown here would also kill our own Escape-to-close listener,
  // which sits on `document`.
  SubxCheckoutPopup.prototype._guardFocus = function () {
    if (window.__subxFocusGuarded) return;   // once per page, not once per popup
    window.__subxFocusGuarded = true;
    var stopInsideOverlay = function (event) {
      var overlay = document.getElementById('subx__cp-overlay');
      if (!overlay || overlay.hidden) return;        // closed — stay out of the way
      if (!overlay.contains(event.target)) return;   // not ours — let the theme have it
      event.stopPropagation();
    };
    window.addEventListener('focusin', stopInsideOverlay, true);
    window.addEventListener('focusout', stopInsideOverlay, true);
  };

  // Shared by shipping (subx__cp-*) and billing (subx__cp-billing-*) field groups.
  SubxCheckoutPopup.prototype._populateLocationSelects = function () {
    this._populateCountrySelect('subx__cp-country');
    this._populateCountrySelect('subx__cp-billing-country');
    // The state list depends on the country now (India states vs South African provinces), so
    // _onCountryChange fills it — and refills it every time the country changes.
    this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    this._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
  };

  SubxCheckoutPopup.prototype._populateCountrySelect = function (countryId) {
    var countrySel = document.getElementById(countryId);
    if (countrySel && !countrySel.options.length) {
      COUNTRY_LIST.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name; opt.textContent = name;
        countrySel.appendChild(opt);
      });
      countrySel.value = DEFAULT_COUNTRY;
    }
  };

  // Fills the State/Province dropdown for one country. Rebuilt whenever the country changes,
  // so switching India → South Africa swaps states for provinces instead of leaving the old
  // list behind; the guard means picking the same country again never clears the customer's
  // choice.
  SubxCheckoutPopup.prototype._populateStateSelect = function (stateSelectId, country) {
    var stateSel = document.getElementById(stateSelectId);
    if (!stateSel) return;
    var list = STATES_BY_COUNTRY[country];
    if (!list || stateSel.getAttribute('data-subx-country') === country) return;
    stateSel.setAttribute('data-subx-country', country);
    stateSel.innerHTML = '';
    // An empty first option, so a customer who never opens the list can't silently send
    // the first state in the alphabet. Real orders went out as "455001 dewas AP" and
    // Shopify flagged "Review address issues"; _validate now makes them choose.
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = country === 'India' ? 'Select state' : 'Select province';
    stateSel.appendChild(placeholder);
    list.forEach(function (name) {
      var opt = document.createElement('option');
      opt.value = name; opt.textContent = name;
      stateSel.appendChild(opt);
    });
  };

  // Shows the State/Province <select> for a country we have a list for (India, South Africa),
  // and falls back to a free-text input for any other country.
  SubxCheckoutPopup.prototype._onCountryChange = function (countryId, stateSelectId, stateTextId) {
    var country = (document.getElementById(countryId) || {}).value || '';
    var stateSel = document.getElementById(stateSelectId);
    var stateText = document.getElementById(stateTextId);
    if (!stateSel || !stateText) return;
    var hasList = !!STATES_BY_COUNTRY[country];
    if (hasList) this._populateStateSelect(stateSelectId, country);
    stateSel.style.display = hasList ? '' : 'none';
    stateText.style.display = hasList ? 'none' : '';
  };

  // Returns whichever State/Province field is currently visible (the select when the country
  // has a list, the free-text box otherwise).
  SubxCheckoutPopup.prototype._getActiveProvinceEl = function (stateSelectId, stateTextId) {
    var stateSel = document.getElementById(stateSelectId);
    if (stateSel && stateSel.style.display !== 'none') return stateSel;
    return document.getElementById(stateTextId);
  };

  SubxCheckoutPopup.prototype._bindEvents = function () {
    var self = this;
    var overlay = this._overlay;
    if (!overlay) return;
    var countrySel = document.getElementById('subx__cp-country');
    if (countrySel) countrySel.addEventListener('change', function () {
      self._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    });
    var billingCountrySel = document.getElementById('subx__cp-billing-country');
    if (billingCountrySel) billingCountrySel.addEventListener('change', function () {
      self._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
    });
    var billingSameCheckbox = document.getElementById('subx__cp-billing-same');
    var billingSection = document.getElementById('subx__cp-billing-section');
    if (billingSameCheckbox && billingSection) {
      billingSameCheckbox.addEventListener('change', function () {
        billingSection.style.display = billingSameCheckbox.checked ? 'none' : '';
      });
    }
    overlay.querySelector('.subx__cp-close').addEventListener('click', function () { self.close(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) self.close();
    });
    document.getElementById('subx__cp-submit').addEventListener('click', function () { self._handleSubmit(); });
    // Any change to the SHIPPING address re-quotes shipping. Billing fields don't affect it.
    ['subx__cp-addr1', 'subx__cp-addr2', 'subx__cp-city', 'subx__cp-province-select',
      'subx__cp-province-text', 'subx__cp-country', 'subx__cp-zip'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () { self._onShippingAddressChanged(); });
      el.addEventListener('change', function () { self._onShippingAddressChanged(); });
    });
    // Ship / Pickup tabs.
    overlay.querySelectorAll('.subx__cp-ship-tab').forEach(function (tab) {
      tab.addEventListener('click', function () { self._selectShippingMode(tab.getAttribute('data-mode')); });
    });
  };

  SubxCheckoutPopup.prototype.open = function (options) {
    var self = this;
    if (!this._ready) { setTimeout(function () { self.open(options); }, 80); return; }
    this._options = options || {};
    this._quote = null;
    this._clearErrors();
    this._resetForm();
    this._fillSummary();
    this._applyCustomerLoginState();
    this._loadPaymentMethods();
    // Cart mode: price the basket straight away so the customer sees real line prices
    // and a real total before typing an address. Shipping is added once they have.
    if (this._options.isCart) {
      this._requestQuote(null, null)
        .then(function () { self._fillCartSummary(); })
        .catch(function (err) {
          console.error('[SubxCheckoutPopup] Could not price the cart:', err);
          self._showGlobalError(err.message || 'Could not price your cart. Please try again.');
        });
    }
    // A saved address is filled in by code, which fires no input event — quote it now,
    // or a logged-in customer would never see (or pay) shipping.
    this._onShippingAddressChanged(true);
    this._overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      var first = document.getElementById('subx__cp-email');
      if (first) first.focus();
    }, 80);
  };

  // Logged-in customers: hide the login banner and auto-fill name/email/phone/address
  // from their Shopify account (passed in via data-customer-* attributes from ms.liquid).
  // Logged-out: show the "Login to use saved addresses" banner with a return-to-this-page link.
  SubxCheckoutPopup.prototype._applyCustomerLoginState = function () {
    var o = this._options;
    var banner = document.getElementById('subx__cp-login-banner');
    var loginBtn = document.getElementById('subx__cp-login-btn');

    if (!o.customerLoggedIn) {
      if (banner) banner.style.display = '';
      if (loginBtn) {
        var base = o.loginUrl || '/account/login';
        var returnUrl = window.location.pathname + window.location.search;
        loginBtn.href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(returnUrl);
      }
      return;
    }

    if (banner) banner.style.display = 'none';

    var emailEl = document.getElementById('subx__cp-email');
    if (emailEl && o.customerEmail) emailEl.value = o.customerEmail;
    var fnameEl = document.getElementById('subx__cp-fname');
    if (fnameEl && o.customerFirstName) fnameEl.value = o.customerFirstName;
    var lnameEl = document.getElementById('subx__cp-lname');
    if (lnameEl && o.customerLastName) lnameEl.value = o.customerLastName;
    var phoneEl = document.getElementById('subx__cp-phone');
    if (phoneEl && o.customerPhone) phoneEl.value = o.customerPhone;

    var addr = o.customerAddress;
    if (addr) {
      var addr1El = document.getElementById('subx__cp-addr1');
      if (addr1El && addr.address1) addr1El.value = addr.address1;
      var addr2El = document.getElementById('subx__cp-addr2');
      if (addr2El && addr.address2) addr2El.value = addr.address2;
      var cityEl = document.getElementById('subx__cp-city');
      if (cityEl && addr.city) cityEl.value = addr.city;
      var zipEl = document.getElementById('subx__cp-zip');
      if (zipEl && addr.zip) zipEl.value = addr.zip;
      if (phoneEl && !phoneEl.value && addr.phone) phoneEl.value = addr.phone;
      var countrySel = document.getElementById('subx__cp-country');
      // Only when the saved country is one we still list — otherwise the <select> would take
      // an empty value and show a blank country, which is worse than leaving the default.
      if (countrySel && addr.country && COUNTRY_LIST.indexOf(addr.country) !== -1) {
          countrySel.value = addr.country;
          this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
      }
      var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
      if (provinceEl && addr.province) provinceEl.value = addr.province;
    }
  };

  SubxCheckoutPopup.prototype.close = function () {
    if (!this._overlay) return;
    this._overlay.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  // ── Cart mode ──────────────────────────────────────────────────────────────
  // The summary lists every cart line. Prices come from the server, never from
  // /cart.js: a prepaid line reads as ONE delivery there while the real charge covers
  // several, because a Shopify discount function can only reduce a price, never
  // multiply it up.
  SubxCheckoutPopup.prototype._fillCartSummary = function () {
    var o = this._options || {};
    var quote = this._quote;
    var self = this;

    // Hide the single-product blocks and make room for the list.
    var productBlock = document.querySelector('.subx__cp-sum-product');
    if (productBlock) productBlock.style.display = 'none';
    var variantRow = document.getElementById('subx__cp-variant-display');
    if (variantRow && variantRow.closest('.subx__cp-row')) variantRow.closest('.subx__cp-row').style.display = 'none';

    var list = document.getElementById('subx__cp-cart-lines');
    if (!list) {
      list = document.createElement('div');
      list.id = 'subx__cp-cart-lines';
      if (productBlock && productBlock.parentNode) {
        productBlock.parentNode.insertBefore(list, productBlock.nextSibling);
      }
    }

    var cartItems = (o.cart && o.cart.items) || [];
    var priced = (quote && quote.lines) || [];
    var currency = (quote && quote.currency) || o.currency || 'INR';

    list.innerHTML = cartItems.map(function (item) {
      var line = priced.find(function (l) { return l.key === item.key; });
      var img = item.image
        ? '<img src="' + item.image + '" alt="" style="width:40px;height:40px;border-radius:6px;object-fit:cover;border:1px solid #eee;flex-shrink:0;"/>'
        : '<div style="width:40px;height:40px;border-radius:6px;background:#f4f4f4;flex-shrink:0;"></div>';
      var planLabel = line && line.isSubscription
        ? (line.planName || (item.properties || {})['Recurring'] || 'Subscription')
        : 'One-time purchase';
      var deliveryNote = line && line.deliveries > 1
        ? '<div style="font-size:11px;color:#777;">' + line.deliveries + ' deliveries prepaid</div>'
        : '';
      var price = line
        ? self._formatMoney(line.lineChargeMinor / 100, currency)
        : '…';
      return ''
        + '<div style="display:flex;gap:10px;align-items:flex-start;padding:8px 0;border-bottom:1px solid #f0f0f0;">'
        +   img
        +   '<div style="flex:1;min-width:0;">'
        +     '<div style="font-size:13px;font-weight:600;color:#111;">' + (item.product_title || item.title || '') + '</div>'
        +     (item.variant_title ? '<div style="font-size:11px;color:#777;">' + item.variant_title + '</div>' : '')
        +     '<div style="font-size:11px;color:#555;">' + planLabel + '</div>'
        +     deliveryNote
        +     '<div style="font-size:11px;color:#777;">Qty ' + (item.quantity || 1) + '</div>'
        +   '</div>'
        +   '<div style="font-size:13px;font-weight:700;color:#111;white-space:nowrap;">' + price + '</div>'
        + '</div>';
    }).join('');

    var nameEl = document.getElementById('subx__cp-product-name');
    if (nameEl) nameEl.textContent = '';
    var planPriceEl = document.getElementById('subx__cp-sum-plan-price');
    if (planPriceEl) {
      planPriceEl.textContent = quote ? this._formatMoney(quote.totals.productsMinor / 100, currency) : '…';
    }
    var planPriceLabel = planPriceEl && planPriceEl.previousElementSibling;
    if (planPriceLabel) planPriceLabel.textContent = 'Items (' + cartItems.length + ')';

    var discountTitleEl = document.getElementById('subx__cp-info-discount-title');
    if (discountTitleEl && quote) {
      var contracts = (quote.groups || []).length;
      discountTitleEl.textContent = contracts > 1
        ? 'You are starting ' + contracts + ' subscriptions — each renews on its own schedule'
        : 'Subscribe once and enjoy ongoing savings on future orders';
    }

    // A new quote may carry new delivery money (the second quote of a pair, or a re-quote
    // after the customer picked another option), so redraw that row too — not just the total.
    this._renderShippingPrice();
    this._updateSubscriptionTotal();
  };

  SubxCheckoutPopup.prototype._fillSummary = function () {
    var o = this._options;
    if (o && o.isCart) { this._fillCartSummary(); return; }
    var nameEl = document.getElementById('subx__cp-product-name');
    if (nameEl) nameEl.textContent = o.productName ? ('You are subscribing to ' + o.productName + ' plan') : '';
    var planEl = document.getElementById('subx__cp-plan-name');
    if (planEl) planEl.textContent = o.sellingPlanName || '';
    // Prepaid plans charge for several deliveries at once, so say so next to the plan name —
    // otherwise the price below looks like one delivery. Hidden whenever there's nothing to say.
    var prepaidEl = document.getElementById('subx__cp-plan-prepaid');
    if (prepaidEl) {
      var prepaidText = o.prepaidInfo || '';
      var planName = o.sellingPlanName || '';
      // The line reads "Delivery every 1 Month, prepay 3 Months", and the plan is very often
      // NAMED "Delivery every 1 Month" — printing both says the same thing twice. Keep only
      // the half the name doesn't already cover ("Prepay 3 Months"). A plan named anything
      // else ("Monthly Box") doesn't match, and keeps the full sentence.
      if (planName && prepaidText.indexOf(planName) === 0) {
        prepaidText = prepaidText.slice(planName.length).replace(/^[\s,;—-]+/, '');
        if (prepaidText) prepaidText = prepaidText.charAt(0).toUpperCase() + prepaidText.slice(1);
      }
      prepaidEl.textContent = prepaidText;
      prepaidEl.style.display = prepaidText ? '' : 'none';
    }
    var variantEl = document.getElementById('subx__cp-variant-display');
    if (variantEl) variantEl.textContent = o.variantTitle || o.productName || '';
    var qty = o.quantity || 1;
    var planPriceEl = document.getElementById('subx__cp-sum-plan-price');
    if (planPriceEl) {
      // A quantity-break tier price already covers the whole quantity, so "× 5" would read
      // as five times too much. Say how many items it is instead.
      planPriceEl.textContent = o.priceIsLineTotal
        ? (o.pricePerCycle || '') + (qty > 1 ? ' (' + qty + ' items)' : '')
        : (o.pricePerCycle || '') + (qty > 1 ? ' × ' + qty : '');
    }
    var totalEl = document.getElementById('subx__cp-sum-total');
    if (totalEl) totalEl.textContent = o.totalPricePerCycle || o.pricePerCycle || '';
    var discountTitleEl = document.getElementById('subx__cp-info-discount-title');
    if (discountTitleEl) {
      discountTitleEl.textContent = o.discountBadgeText ? ('Subscribe once and enjoy ' + o.discountBadgeText + ' off on all future orders') : 'Subscribe once and enjoy ongoing savings on future orders';
    }
    var imgWrap = document.getElementById('subx__cp-img-wrap');
    if (imgWrap) {
      if (o.imageUrl) {
        imgWrap.innerHTML = '<img src="' + o.imageUrl + '" alt="' + (o.productName || '') + '"/>';
      } else {
        imgWrap.innerHTML = '&#128717;';
      }
    }
  };

  SubxCheckoutPopup.prototype._resetForm = function () {
    var ids = ['subx__cp-email', 'subx__cp-fname', 'subx__cp-lname', 'subx__cp-phone',
      'subx__cp-addr1', 'subx__cp-addr2', 'subx__cp-city', 'subx__cp-province-text', 'subx__cp-zip',
      'subx__cp-billing-addr1', 'subx__cp-billing-addr2', 'subx__cp-billing-city',
      'subx__cp-billing-province-text', 'subx__cp-billing-zip'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.value = ''; el.classList.remove('subx__cp-invalid'); }
    });
    var countrySel = document.getElementById('subx__cp-country');
    if (countrySel) { countrySel.value = DEFAULT_COUNTRY; countrySel.classList.remove('subx__cp-invalid'); }
    var stateSel = document.getElementById('subx__cp-province-select');
    if (stateSel) { stateSel.selectedIndex = 0; stateSel.classList.remove('subx__cp-invalid'); }
    var billingCountrySel = document.getElementById('subx__cp-billing-country');
    if (billingCountrySel) { billingCountrySel.value = DEFAULT_COUNTRY; billingCountrySel.classList.remove('subx__cp-invalid'); }
    var billingStateSel = document.getElementById('subx__cp-billing-province-select');
    if (billingStateSel) { billingStateSel.selectedIndex = 0; billingStateSel.classList.remove('subx__cp-invalid'); }
    this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    this._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
    var billingSameCheckbox = document.getElementById('subx__cp-billing-same');
    var billingSection = document.getElementById('subx__cp-billing-section');
    if (billingSameCheckbox) billingSameCheckbox.checked = true;
    if (billingSection) billingSection.style.display = 'none';
    var cardRadio = document.getElementById('subx__payement-option-card');
    if (cardRadio) cardRadio.checked = true;
    this._resetShipping();
    this._setLoading(false);
  };

  // ── Payment method (Card / UPI) ───────────────────────────────────────────
  // One authorisation creates a mandate on ONE instrument, so the customer picks before
  // Razorpay Checkout opens. Only tokenization can offer the choice, and only when the
  // merchant has switched UPI Autopay on in the app — so the server is asked, never the
  // storefront. Card-only until it answers: a UPI mandate on a shop with the setting off
  // would be refused by /pre-order anyway, after the customer had already chosen it.

  SubxCheckoutPopup.prototype._setPaymentMethods = function (methods) {
    var row = document.getElementById('subx__cp-payment-row');
    if (!row) return;
    var list = methods && methods.length ? methods : ['card'];
    var hasCard = list.indexOf('card') !== -1;
    var hasUpi = list.indexOf('upi') !== -1;
    var cardLabel = document.getElementById('subx__cp-method-card');
    var upiLabel = document.getElementById('subx__cp-method-upi');
    var upiRadio = document.getElementById('subx__payement-option-upi');
    var cardRadio = document.getElementById('subx__payement-option-card');
    if (cardLabel) cardLabel.style.display = hasCard ? '' : 'none';
    if (upiLabel) upiLabel.style.display = hasUpi ? '' : 'none';
    if (!hasUpi && upiRadio && upiRadio.checked && cardRadio) cardRadio.checked = true;
    // Nothing to choose between = don't ask.
    row.style.display = hasCard && hasUpi ? '' : 'none';
  };

  SubxCheckoutPopup.prototype._loadPaymentMethods = function () {
    var self = this;
    var o = this._options || {};
    this._setPaymentMethods(['card']);

    // A known gateway that is not tokenization has no choice to offer — don't ask.
    // An empty gateway (the cart page carries no widget) still asks; the server knows.
    var gateway = String(o.gateway || '').toUpperCase();
    if (gateway && gateway !== 'RAZORPAY_RECURRING') return;

    if (window.SUBX && window.SUBX.paymentMethods) {
      this._setPaymentMethods(window.SUBX.paymentMethods);
      return;
    }

    var shop = o.shop || (window.Shopify && window.Shopify.shop) || '';
    fetch(SUBX_APP_URL + '/api/external/checkout/payment-methods?shop=' + encodeURIComponent(shop), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: shop }),
    })
    .then(function (response) { return response.json(); })
    .then(function (body) {
      var methods = body && body.status && body.result && body.result.methods;
      if (!methods || !methods.length) return;
      if (window.SUBX) window.SUBX.paymentMethods = methods;
      self._setPaymentMethods(methods);
    })
    .catch(function (err) {
      // Card stays selected and the row stays hidden — the safe end of the fallback.
      console.warn('SUBX: could not read the payment methods', err);
    });
  };

  SubxCheckoutPopup.prototype._clearErrors = function () {
    document.querySelectorAll('.subx__cp-field-err').forEach(function (el) {
      el.textContent = ''; el.classList.remove('subx__cp-show');
    });
    var ge = document.getElementById('subx__cp-global-err');
    if (ge) { ge.textContent = ''; ge.classList.remove('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._fieldErr = function (inputId, errId, msg) {
    var inp = document.getElementById(inputId);
    var err = document.getElementById(errId);
    if (inp) inp.classList.add('subx__cp-invalid');
    if (err) { err.textContent = msg; err.classList.add('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._validate = function () {
    this._clearErrors();
    var valid = true;
    var self = this;

    var email = (document.getElementById('subx__cp-email') || {}).value || '';
    email = email.trim();
    if (!email) { self._fieldErr('subx__cp-email', 'subx__cp-email-err', 'Email is required'); valid = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { self._fieldErr('subx__cp-email', 'subx__cp-email-err', 'Enter a valid email address'); valid = false; }

    if (!((document.getElementById('subx__cp-fname') || {}).value || '').trim()) { self._fieldErr('subx__cp-fname', 'subx__cp-fname-err', 'First name is required'); valid = false; }
    if (!((document.getElementById('subx__cp-lname') || {}).value || '').trim()) { self._fieldErr('subx__cp-lname', 'subx__cp-lname-err', 'Last name is required'); valid = false; }

    var phone = ((document.getElementById('subx__cp-phone') || {}).value || '').trim();
    if (!phone) { self._fieldErr('subx__cp-phone', 'subx__cp-phone-err', 'Phone number is required'); valid = false; }
    else if (!subxNormaliseIndianPhone(phone)) {
      self._fieldErr('subx__cp-phone', 'subx__cp-phone-err', 'Enter a 10-digit Indian mobile number, e.g. 9876543210');
      valid = false;
    }

    if (!((document.getElementById('subx__cp-addr1') || {}).value || '').trim()) { self._fieldErr('subx__cp-addr1', 'subx__cp-addr1-err', 'Address is required'); valid = false; }
    if (!((document.getElementById('subx__cp-city') || {}).value || '').trim()) { self._fieldErr('subx__cp-city', 'subx__cp-city-err', 'City is required'); valid = false; }

    var provinceEl = self._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    if (!((provinceEl || {}).value || '').trim()) { self._fieldErr(provinceEl ? provinceEl.id : 'subx__cp-province-text', 'subx__cp-province-err', 'State / Province is required'); valid = false; }

    if (!((document.getElementById('subx__cp-country') || {}).value || '').trim()) { self._fieldErr('subx__cp-country', 'subx__cp-country-err', 'Country is required'); valid = false; }
    if (!((document.getElementById('subx__cp-zip') || {}).value || '').trim()) { self._fieldErr('subx__cp-zip', 'subx__cp-zip-err', 'Postal code is required'); valid = false; }

    var billingSame = (document.getElementById('subx__cp-billing-same') || {}).checked;
    if (!billingSame) {
      if (!((document.getElementById('subx__cp-billing-addr1') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-addr1', 'subx__cp-billing-addr1-err', 'Address is required'); valid = false; }
      if (!((document.getElementById('subx__cp-billing-city') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-city', 'subx__cp-billing-city-err', 'City is required'); valid = false; }

      var billingProvinceEl = self._getActiveProvinceEl('subx__cp-billing-province-select', 'subx__cp-billing-province-text');
      if (!((billingProvinceEl || {}).value || '').trim()) { self._fieldErr(billingProvinceEl ? billingProvinceEl.id : 'subx__cp-billing-province-text', 'subx__cp-billing-province-err', 'State / Province is required'); valid = false; }

      if (!((document.getElementById('subx__cp-billing-country') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-country', 'subx__cp-billing-country-err', 'Country is required'); valid = false; }
      if (!((document.getElementById('subx__cp-billing-zip') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-zip', 'subx__cp-billing-zip-err', 'Postal code is required'); valid = false; }
    }

    // Shipping must be settled before paying. Checked only once the form itself is valid,
    // so the customer sees their field errors first.
    if (valid) {
      var shipping = self._shipping || {};
      if (shipping.requoting) {
        // Cart mode: a delivery option was just picked and the basket is being re-priced.
        // Paying now would send the old total's expectations into pre-order.
        self._showGlobalError('Please wait — the total is being updated.');
        valid = false;
      } else if (shipping.state === 'loading') {
        self._showGlobalError('Please wait — shipping is still being calculated.');
        valid = false;
      } else if (shipping.state === 'error') {
        self._showGlobalError("We couldn't calculate shipping. Check the address or tap Try again.");
        valid = false;
      } else if (shipping.state === 'ready' && !shipping.selected) {
        self._showGlobalError('Please choose a shipping option.');
        valid = false;
      } else if (shipping.state === 'idle') {
        // Address is complete but no quote was ever asked for — ask now.
        self._onShippingAddressChanged(true, true);
        self._showGlobalError('Please wait — shipping is still being calculated.');
        valid = false;
      }
    }

    return valid;
  };

  SubxCheckoutPopup.prototype._getFormData = function () {
    var o = this._options;
    var v = function (id) { return ((document.getElementById(id) || {}).value || '').trim(); };
    var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    var shippingAddress = {
      address1: v('subx__cp-addr1'),
      address2: v('subx__cp-addr2'),
      city: v('subx__cp-city'),
      province: ((provinceEl || {}).value || '').trim(),
      country: v('subx__cp-country'),
      zip: v('subx__cp-zip'),
    };

    var billingSame = (document.getElementById('subx__cp-billing-same') || {}).checked;
    var billingAddress;
    if (billingSame) {
        billingAddress = shippingAddress;
    } else {
      var billingProvinceEl = this._getActiveProvinceEl('subx__cp-billing-province-select', 'subx__cp-billing-province-text');
      billingAddress = {
        address1: v('subx__cp-billing-addr1'),
        address2: v('subx__cp-billing-addr2'),
        city: v('subx__cp-billing-city'),
        province: ((billingProvinceEl || {}).value || '').trim(),
        country: v('subx__cp-billing-country'),
        zip: v('subx__cp-billing-zip'),
      };
    }

    var pickedRate = (this._shipping && this._shipping.state === 'ready' && this._shipping.selected) || null;

    var payment_method = (document.querySelector('#subx__cp-payment-options input[name="payment_options"]:checked') || {}).value || ''

    return {
      shop: o.shop || '',
      gateway: o.gateway || 'RAZORPAY',
      // Cart checkout sends the whole basket instead of one variant + plan. The server
      // branches on `items` being present; without it this is the original
      // single-product request, unchanged.
      ...(o.isCart
        ? { items: o.items || [], currency: o.currency || '', currencyRate: o.currencyRate || 1 }
        : {}),
      variantId: o.variantId || '',
      sellingPlanId: o.sellingPlanId || '',
      quantity: o.quantity || 1,
      email: v('subx__cp-email'),
      firstName: v('subx__cp-fname'),
      lastName: v('subx__cp-lname'),
      // Always +91XXXXXXXXXX — _validate has already refused anything that can't be
      // read as an Indian mobile, so this never silently sends a number Shopify rejects.
      phone: subxNormaliseIndianPhone(v('subx__cp-phone')),
      address1: shippingAddress.address1,
      address2: shippingAddress.address2,
      city: shippingAddress.city,
      province: shippingAddress.province,
      country: shippingAddress.country,
      zip: shippingAddress.zip,
      billingAddress: billingAddress,
      // WHICH quantity-break tier was picked — never its discount. The server looks the tier
      // up again, checks the merchant still offers it, and works out the price itself.
      selectedTierId: o.selectedTierId || '',
      // WHICH option was picked — never its price. The server re-quotes it with Shopify
      // and charges Shopify's price. All empty when Shopify had nothing for the address.
      shippingRateHandle: pickedRate ? (pickedRate.handle || '') : '',
      shippingRateTitle: pickedRate ? (pickedRate.title || '') : '',
      // SHIPPING / LOCAL_DELIVERY / PICKUP, and for a pickup, which store.
      shippingRateType: pickedRate ? (pickedRate.type || '') : '',
      pickupLocationId: pickedRate && pickedRate.type === 'PICKUP' ? (pickedRate.locationId || '') : '',
      paymentMethod: payment_method
    };
  };

  // ── Shipping ──────────────────────────────────────────────────────────────
  // Shows every delivery option Shopify checkout would show for the address being typed,
  // laid out like checkout: a Ship tab (local delivery first, then shipping rates) and a
  // Pickup tab (store pickup) — the tabs only when the store offers both. Only WHICH option
  // was picked (handle, title, type, pickup store) is ever sent to the server, never a
  // price: pre-order re-quotes it with Shopify and charges Shopify's price, so editing the
  // request can't lower shipping. States:
  //   idle    — shipping address not complete yet
  //   loading — asking the server (Pay disabled)
  //   ready   — options to pick from
  //   none    — Shopify has nothing for this address → "calculated later", Pay allowed
  //   error   — lookup failed or address rejected (Pay disabled, never free shipping)

  SubxCheckoutPopup.prototype._resetShipping = function () {
    clearTimeout(this._shippingTimer);
    this._shipping = {
      state: 'idle',
      rates: [],          // every option, each with its type
      selected: null,
      mode: 'SHIP',       // the open tab: SHIP or PICKUP
      prefs: { SHIP: null, PICKUP: null }, // the customer's last pick on each tab, kept across re-quotes
      prefMode: null,     // the tab of that last pick
      addressKey: null,   // the address the current rates were quoted for
      // Cart mode: true while the server is re-pricing the basket for a newly picked
      // option. Pay is blocked meanwhile, so nobody can pay on the previous option's total.
      requoting: false,
      // Bumped on every new quote; an answer carrying an older number is dropped.
      reqId: ((this._shipping && this._shipping.reqId) || 0) + 1,
    };
    this._renderShipping();
  };

  SubxCheckoutPopup.prototype._getShippingAddress = function () {
    var v = function (id) { return ((document.getElementById(id) || {}).value || '').trim(); };
    var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    return {
      address1: v('subx__cp-addr1'),
      address2: v('subx__cp-addr2'),
      city: v('subx__cp-city'),
      province: ((provinceEl || {}).value || '').trim(),
      country: v('subx__cp-country'),
      zip: v('subx__cp-zip'),
    };
  };

  SubxCheckoutPopup.prototype._isShippingAddressReady = function (address) {
    return !!(address.country && address.province && address.city && address.zip);
  };

  // Runs on every shipping-address edit (debounced), on open, and on "Try again". Clears the
  // current pick straight away, so a price quoted for an OLD address can never be paid.
  SubxCheckoutPopup.prototype._onShippingAddressChanged = function (immediate, force) {
    var self = this;
    var sh = this._shipping;
    if (!sh) return;
    var address = this._getShippingAddress();
    var key = JSON.stringify(address);
    // One edit fires input AND change (and change again on blur) — don't re-quote when
    // nothing actually changed.
    if (!force && key === sh.addressKey && sh.state !== 'error' && sh.state !== 'idle') return;

    clearTimeout(this._shippingTimer);
    sh.reqId++;
    sh.rates = [];
    sh.selected = null;
    sh.addressKey = key;
    sh.state = this._isShippingAddressReady(address) ? 'loading' : 'idle';
    this._renderShipping();
    if (sh.state !== 'loading') return;
    this._shippingTimer = setTimeout(function () { self._calculateShippingRates(); }, immediate ? 0 : 600);
  };

  // Asks the server what this cart costs. Called on open with no address (to show the
  // line prices), again once the address is complete (to get the delivery options), and
  // again when an option is picked (which is when the full shipping can be worked out —
  // a prepaid group pays for the extra parcels it will need inside this window).
  SubxCheckoutPopup.prototype._requestQuote = function (address, picked) {
    var self = this;
    var o = this._options || {};
    var shop = o.shop || (window.Shopify && window.Shopify.shop) || '';

    return fetch(SUBX_APP_URL + '/api/external/checkout/quote?shop=' + encodeURIComponent(shop), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: shop,
        items: o.items || [],
        currency: o.currency || '',
        currencyRate: o.currencyRate || 1,
        shipping_address: address || undefined,
        shippingRateHandle: (picked && picked.handle) || '',
        shippingRateTitle: (picked && picked.title) || '',
        shippingRateType: (picked && picked.type) || '',
        pickupLocationId: (picked && picked.type === 'PICKUP' && picked.locationId) || '',
      }),
    })
    .then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || !body.status || !body.result) {
          throw new Error((body && body.message) || 'Could not price your cart');
        }
        self._quote = body.result;
        return body.result;
      });
    });
  };

  SubxCheckoutPopup.prototype._calculateShippingRates = function () {
    var self = this;
    var o = this._options || {};
    var sh = this._shipping;
    var address = this._getShippingAddress();
    if (!sh || !this._isShippingAddressReady(address)) return;

    // Cart mode asks /quote instead of /shipping-rates: one call returns the line
    // prices AND the delivery options, and it is the only thing that knows what a
    // prepaid group's extra parcels cost. The options are mapped into the same shape
    // the single-product flow uses, so the whole shipping UI below is unchanged.
    if (o.isCart) {
      var cartReqId = ++sh.reqId;
      sh.addressKey = JSON.stringify(address);
      sh.state = 'loading';
      sh.rates = [];
      sh.selected = null;
      this._renderShipping();

      var picked = sh.prefs && sh.prefMode ? sh.prefs[sh.prefMode] : null;
      this._requestQuote(address, picked)
        .then(function (quote) {
          if (sh !== self._shipping || cartReqId !== sh.reqId) return;
          var options = (quote.delivery && quote.delivery.options) || [];
          sh.rates = options.map(function (opt) {
            return {
              type: opt.type,
              handle: opt.handle,
              title: opt.title,
              price: (opt.basketMinor / 100).toFixed(2),
              currency: quote.currency || o.currency || 'INR',
              deliveries: 1,
              total: (opt.basketMinor / 100).toFixed(2),
              locationId: opt.locationId,
              instructions: opt.instructions || '',
            };
          });
          sh.state = sh.rates.length ? 'ready' : 'none';
          sh.selected = sh.rates.length ? self._findPreferredRate(sh.rates) : null;
          sh.mode = self._isPickup(sh.selected) ? 'PICKUP' : 'SHIP';
          self._fillCartSummary();
          self._renderShipping();

          // A rate is now chosen, so ask once more for the real total — it includes the
          // extra parcels every prepaid group pays for up front. Goes through the same
          // helper a manual pick uses, so Pay is disabled and the total reads "…" until the
          // answer lands. It used to run bare, which left Pay live for about a second over a
          // products-only total while the real charge was already going to be higher
          // (29 Sep 2026).
          if (sh.selected) self._requoteForPick();
        })
        .catch(function (err) {
          if (sh !== self._shipping || cartReqId !== sh.reqId) return;
          console.error('[SubxCheckoutPopup] Cart quote error:', err);
          sh.rates = [];
          sh.selected = null;
          sh.state = 'error';
          self._renderShipping();
        });
      return;
    }

    var reqId = ++sh.reqId;
    sh.addressKey = JSON.stringify(address);
    sh.state = 'loading';
    sh.rates = [];
    sh.selected = null;
    this._renderShipping();

    var shop = o.shop || (window.Shopify && window.Shopify.shop) || '';
    var isStale = function () { return sh !== self._shipping || reqId !== sh.reqId; };

    fetch(SUBX_APP_URL + '/api/external/checkout/shipping-rates?shop=' + encodeURIComponent(shop), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: shop,
        sellingPlanId: o.sellingPlanId || '',
        selectedTierId: o.selectedTierId || '',
        line_items: { variantId: o.variantId || '', quantity: Number(o.quantity || 1) },
        shipping_address: address,
      }),
    })
    .then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || !body.status || !Array.isArray(body.result)) {
          throw new Error((body && body.message) || 'Shipping rate request failed');
        }
        return body.result;
      });
    })
    .then(function (rates) {
      if (isStale()) return; // a newer address is being quoted — drop this answer
      sh.rates = rates;
      sh.state = rates.length ? 'ready' : 'none';
      sh.selected = rates.length ? self._findPreferredRate(rates) : null;
      sh.mode = self._isPickup(sh.selected) ? 'PICKUP' : 'SHIP';
      self._renderShipping();
    })
    .catch(function (err) {
      if (isStale()) return;
      console.error('[SubxCheckoutPopup] Shipping rate error:', err);
      sh.rates = [];
      sh.selected = null;
      sh.state = 'error';
      self._renderShipping();
    });
  };

  SubxCheckoutPopup.prototype._isPickup = function (rate) {
    return !!rate && rate.type === 'PICKUP';
  };

  // The options on one tab, in Shopify's order. SHIP = local delivery + shipping rates.
  SubxCheckoutPopup.prototype._ratesForMode = function (mode) {
    var self = this;
    var rates = (this._shipping && this._shipping.rates) || [];
    return rates.filter(function (rate) { return self._isPickup(rate) === (mode === 'PICKUP'); });
  };

  // The option in `rates` that is the same as an earlier pick: same handle, else the same
  // pickup store, else the same type and title. null when it's gone.
  SubxCheckoutPopup.prototype._matchPick = function (rates, pick) {
    if (!pick) return null;
    var i;
    for (i = 0; i < rates.length; i++) {
      if (pick.handle && rates[i].handle === pick.handle) return rates[i];
    }
    for (i = 0; i < rates.length; i++) {
      if (pick.locationId && rates[i].locationId === pick.locationId) return rates[i];
    }
    for (i = 0; i < rates.length; i++) {
      if (pick.title && rates[i].title === pick.title && (rates[i].type || '') === pick.type) return rates[i];
    }
    return null;
  };

  // Keeps the customer's earlier pick across re-quotes (address edit, retry); otherwise
  // what checkout picks — the first Ship option, or the first store when the address has
  // nothing to ship.
  SubxCheckoutPopup.prototype._findPreferredRate = function (rates) {
    var self = this;
    var sh = this._shipping || {};
    var kept = sh.prefMode && sh.prefs ? this._matchPick(rates, sh.prefs[sh.prefMode]) : null;
    if (kept) return kept;
    var ship = rates.filter(function (rate) { return !self._isPickup(rate); });
    return ship.length ? ship[0] : rates[0];
  };

  SubxCheckoutPopup.prototype._rememberPick = function (rate) {
    var sh = this._shipping;
    var mode = this._isPickup(rate) ? 'PICKUP' : 'SHIP';
    sh.prefs[mode] = { handle: rate.handle, title: rate.title, type: rate.type || '', locationId: rate.locationId || '' };
    sh.prefMode = mode;
  };

  // Cart mode only. A different delivery option changes the WHOLE charge, not just one
  // parcel: every prepaid group pays for its own extra parcels at the new option's price.
  // Only the server knows how many, so ask it again and re-draw. Without this the popup
  // kept the old total while pre-order went on to charge the new one — picking Express on a
  // 10-delivery prepaid line showed ₹598.65 and charged ₹1,448.65 (29 Sep 2026).
  SubxCheckoutPopup.prototype._requoteForPick = function () {
    var self = this;
    var o = this._options || {};
    var sh = this._shipping;
    if (!o.isCart || !sh || !sh.selected) return;
    var address = this._getShippingAddress();
    if (!this._isShippingAddressReady(address)) return;

    // Same guard the other quotes use: bump the id, and drop any answer that isn't the
    // newest. Clicking through three options leaves only the last one's total on screen.
    var pickReqId = ++sh.reqId;
    sh.requoting = true;
    this._renderShippingPrice();
    this._updateSubscriptionTotal();
    this._syncSubmitButton();

    this._requestQuote(address, sh.selected)
      .then(function () {
        if (sh !== self._shipping || pickReqId !== sh.reqId) return;
        sh.requoting = false;
        self._fillCartSummary();     // line prices and the total
        self._renderShippingPrice();
        self._syncSubmitButton();
      })
      .catch(function (err) {
        if (sh !== self._shipping || pickReqId !== sh.reqId) return;
        console.error('[SubxCheckoutPopup] Cart re-quote error:', err);
        // Never leave a total on screen that we can't stand behind — go to the error
        // state, which blocks Pay and offers Try again.
        sh.requoting = false;
        sh.state = 'error';
        self._renderShipping();
      });
  };

  SubxCheckoutPopup.prototype._selectShippingRate = function (index) {
    var sh = this._shipping;
    if (!sh || sh.state !== 'ready' || !sh.rates[index]) return;
    sh.selected = sh.rates[index];
    this._rememberPick(sh.selected);
    this._renderShippingPrice();
    this._updateSubscriptionTotal();
    this._requoteForPick();   // cart mode only; returns at once for a single product
  };

  // Ship / Pickup tab: shows that tab's options and picks the customer's earlier choice on
  // it, or its first option.
  SubxCheckoutPopup.prototype._selectShippingMode = function (mode) {
    var sh = this._shipping;
    if (!sh || sh.state !== 'ready' || sh.mode === mode) return;
    var list = this._ratesForMode(mode);
    if (!list.length) return;
    sh.mode = mode;
    sh.selected = this._matchPick(list, sh.prefs[mode]) || list[0];
    this._rememberPick(sh.selected);
    this._renderShipping();
    this._requoteForPick();   // switching to Pickup usually makes delivery free — re-price it
  };

  SubxCheckoutPopup.prototype._formatMoney = function (amount, currency) {
    var n = Number(amount || 0);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'INR' }).format(n);
    } catch (e) {
      return (currency ? currency + ' ' : '') + n.toFixed(2);
    }
  };

  // Rate titles come from the store's shipping settings — escaped before going into HTML.
  SubxCheckoutPopup.prototype._escapeHtml = function (value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  // "₹50.00 × 3 deliveries = ₹150.00" for a prepaid plan, plain "₹50.00" otherwise.
  SubxCheckoutPopup.prototype._describeRate = function (rate) {
    var deliveries = Number(rate.deliveries || 1);
    var total = this._formatMoney(rate.total || rate.price, rate.currency);
    if (deliveries > 1) {
      return this._formatMoney(rate.price, rate.currency) + ' × ' + deliveries + ' deliveries = ' + total;
    }
    return total;
  };

  // "Free" for ₹0 — pickup, free local delivery — like checkout; otherwise the billing's total.
  SubxCheckoutPopup.prototype._priceText = function (rate) {
    var amount = Number(rate.total || rate.price || 0);
    return amount === 0 ? 'Free' : this._formatMoney(amount, rate.currency);
  };

  SubxCheckoutPopup.prototype._renderShippingPrice = function () {
    var priceEl = document.getElementById('subx__cp-shipping-price');
    if (!priceEl) return;
    var o = this._options || {};
    var sh = this._shipping || {};
    var labelEl = document.getElementById('subx__cp-shipping-label');
    if (labelEl) labelEl.textContent = sh.state === 'ready' && this._isPickup(sh.selected) ? 'Pickup' : 'Shipping';
    // Cart mode shows the delivery money that is REALLY being charged: the basket parcel
    // plus the extra parcels every prepaid group pays for up front. The price beside each
    // radio is one parcel, and printing that here made the summary read
    // "Items ₹248.65 + Shipping ₹35.00 = ₹598.65" — three numbers that don't add up
    // (29 Sep 2026). Only a quote made WITH a chosen option carries it, hence `chosen`.
    if (o.isCart) {
      if (sh.state === 'loading' || sh.requoting) { priceEl.textContent = 'Calculating…'; return; }
      var quote = this._quote;
      if (quote && quote.delivery && quote.delivery.chosen) {
        var shipMinor = quote.totals.shippingMinor || 0;
        priceEl.textContent = shipMinor === 0
          ? 'Free'
          : this._formatMoney(shipMinor / 100, quote.currency || o.currency || 'INR');
      } else {
        priceEl.textContent = sh.state === 'ready' && sh.selected ? 'Calculating…' : '—';
      }
      return;
    }
    if (sh.state === 'loading') {
      priceEl.textContent = 'Calculating…';
    } else if (sh.state === 'ready' && sh.selected) {
      priceEl.textContent = this._priceText(sh.selected);
    } else {
      priceEl.textContent = '—';
    }
  };

  SubxCheckoutPopup.prototype._renderShipping = function () {
    var self = this;
    var sh = this._shipping || { state: 'idle', rates: [] };
    var optionsEl = document.getElementById('subx__cp-shipping-options');
    var listEl = document.getElementById('subx__cp-shipping-list');
    var statusEl = document.getElementById('subx__cp-shipping-status');
    if (!optionsEl || !listEl || !statusEl) return;

    this._renderShippingPrice();

    var tabsEl = document.getElementById('subx__cp-ship-tabs');
    var optionsLabelEl = document.getElementById('subx__cp-shipping-options-label');
    if (sh.state === 'ready') {
      var hasShip = this._ratesForMode('SHIP').length > 0;
      var hasPickup = this._ratesForMode('PICKUP').length > 0;
      // Rows for the open tab only; each radio's value is its index in the full list.
      listEl.innerHTML = sh.rates.map(function (rate, index) {
        if (self._isPickup(rate) !== (sh.mode === 'PICKUP')) return '';
        var deliveries = Number(rate.deliveries || 1);
        var sub = '';
        if (self._isPickup(rate)) {
          sub = rate.instructions || '';          // e.g. "Usually ready in 24 hours"
        } else if (deliveries > 1 && Number(rate.price) > 0) {
          sub = self._describeRate(rate);          // "₹50.00 × 3 deliveries = ₹150.00"
        }
        return '<label class="subx__cp-ship-rate">' +
          '<input type="radio" name="subx_shipping_rate" value="' + index + '"' + (rate === sh.selected ? ' checked' : '') + '/>' +
          '<span class="subx__cp-ship-rate-title">' + self._escapeHtml(rate.title || (self._isPickup(rate) ? 'Store pickup' : 'Shipping')) +
            (sub ? '<span class="subx__cp-ship-rate-sub">' + self._escapeHtml(sub) + '</span>' : '') +
          '</span>' +
          '<span class="subx__cp-ship-rate-price">' + self._escapeHtml(self._priceText(rate)) + '</span>' +
          '</label>';
      }).join('');
      listEl.querySelectorAll('input[name="subx_shipping_rate"]').forEach(function (input) {
        input.addEventListener('change', function () { self._selectShippingRate(Number(input.value)); });
      });
      if (tabsEl) {
        tabsEl.style.display = hasShip && hasPickup ? '' : 'none';
        tabsEl.querySelectorAll('.subx__cp-ship-tab').forEach(function (tab) {
          var active = tab.getAttribute('data-mode') === sh.mode;
          tab.classList.toggle('subx__cp-active', active);
          tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      if (optionsLabelEl) {
        optionsLabelEl.textContent = hasShip && hasPickup ? 'Delivery Method' : (hasPickup ? 'Pickup Location' : 'Shipping Method');
      }
      optionsEl.style.display = '';
    } else {
      listEl.innerHTML = '';
      if (tabsEl) tabsEl.style.display = 'none';
      optionsEl.style.display = 'none';
    }

    statusEl.className = 'subx__cp-ship-status';
    statusEl.innerHTML = '';
    if (sh.state === 'idle') {
      statusEl.textContent = 'Enter your address to see shipping';
    } else if (sh.state === 'none') {
      statusEl.textContent = 'Shipping will be calculated later';
    } else if (sh.state === 'error') {
      statusEl.className = 'subx__cp-ship-status subx__cp-ship-error';
      statusEl.appendChild(document.createTextNode("Couldn't calculate shipping. Check the address or "));
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'subx__cp-ship-retry';
      retry.textContent = 'Try again';
      retry.addEventListener('click', function () { self._onShippingAddressChanged(true, true); });
      statusEl.appendChild(retry);
    }
    statusEl.style.display = statusEl.childNodes.length ? '' : 'none';

    this._updateSubscriptionTotal();
    this._syncSubmitButton();
  };

  SubxCheckoutPopup.prototype._updateSubscriptionTotal = function () {
    var o = this._options || {};
    var totalEl = document.getElementById('subx__cp-sum-total');
    if (!totalEl) return;

    // Cart mode: the server's number, always. It is the only one that knows the prepaid
    // multipliers and the extra parcels, and it is exactly what will be charged.
    if (o.isCart) {
      // While a re-quote is in flight the stored total belongs to the PREVIOUS option, so
      // show nothing rather than a number that is about to change.
      if (!this._quote || (this._shipping && this._shipping.requoting)) { totalEl.textContent = '…'; return; }
      totalEl.textContent = this._formatMoney(
        this._quote.totals.chargeMinor / 100,
        this._quote.currency || o.currency || 'INR'
      );
      return;
    }

    var sh = this._shipping || {};
    var rate = sh.state === 'ready' ? sh.selected : null;
    if (!rate) {
      // No shipping chosen (yet) — the plan total, exactly as before.
      totalEl.textContent = o.totalPricePerCycle || o.pricePerCycle || '';
      return;
    }
    var currency = rate.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    totalEl.textContent = this._formatMoney(Number(o.totalPriceNumeric || 0) + Number(rate.total || rate.price || 0), currency);
  };

  // Pay stays disabled while shipping is loading or failed — never pay on a stale or
  // missing quote. Left alone while a submit is in flight (_setLoading owns it then).
  SubxCheckoutPopup.prototype._syncSubmitButton = function () {
    var btn = document.getElementById('subx__cp-submit');
    if (!btn || this._submitting) return;
    var sh = this._shipping || {};
    btn.disabled = sh.state === 'loading' || sh.state === 'error' || !!sh.requoting;
  };

  SubxCheckoutPopup.prototype._setLoading = function (on) {
    var btn = document.getElementById('subx__cp-submit');
    if (!btn) return;
    this._submitting = !!on;
    btn.disabled = !!on;
    btn.textContent = on ? 'Processing…' : 'Proceed to Payment';
    if (!on) this._syncSubmitButton();
  };

  SubxCheckoutPopup.prototype._showGlobalError = function (msg) {
    var el = document.getElementById('subx__cp-global-err');
    if (el) { el.textContent = msg; el.classList.add('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._handleSubmit = function () {
    if (!this._validate()) return;
    var data = this._getFormData();
    var self = this;
    var shop = data.shop || (window.Shopify && window.Shopify.shop) || '';
    // Shared pre-order route — dispatches to whichever gateway (Razorpay, Paystack,
    // or Razorpay Recurring) this shop actually has connected, instead of hardcoding
    // to the original Razorpay-only endpoint.
    var url = SUBX_APP_URL + '/api/external/checkout/pre-order?shop=' + encodeURIComponent(shop);

    this._clearErrors();
    this._setLoading(true);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    .then(function (response) { return response.json(); })
    .then(function (result) {
      if (result.status && result.result && result.result.key_id &&
          (result.result.subscription_id || (result.result.order_id && result.result.customer_id))) {
        // Razorpay popup flow (either Subscriptions mode or Recurring/tokenization
        // mode): pay in-page instead of leaving the store, so we can send the
        // customer back to their account afterwards.
        self._openRazorpayCheckout(result.result);
      } else if (result.status && result.result && result.result.redirect_url) {
        // Paystack, and any Razorpay Recurring response that didn't include the
        // above (older backend), still redirect to their own hosted payment page.
        window.location.href = result.result.redirect_url;
      } else {
        self._setLoading(false);
        self._showGlobalError(result.message || 'Something went wrong. Please try again.');
        // Re-quote in case the server refused a rate that's no longer offered
        // ("Shipping options have changed"). Keeps the customer's pick if still there.
        self._onShippingAddressChanged(true, true);
      }
    })
    .catch(function (err) {
      console.error('[SubxCheckoutPopup] Network error:', err);
      self._setLoading(false);
      self._showGlobalError('Network error. Please check your connection and try again.');
    });
  };

  // Opens Razorpay's Checkout.js modal for the mandate/first-charge authorization
  // right on the store page, for either Razorpay gateway this app supports:
  //   - Subscriptions mode: subscription_id. subscription.authenticated /
  //     subscription.charged webhooks provision the contract server-side (see
  //     razorpay-contract-service.js).
  //   - Recurring/tokenization mode: order_id + customer_id (Standard Checkout
  //     with recurring:true). payment.captured/payment.authorized webhooks
  //     provision the contract server-side (see webhook-handler.js).
  // Either way this only needs to hand the customer back to their account once
  // Razorpay confirms the payment — provisioning itself is webhook-driven, not
  // dependent on this popup succeeding or even staying open.
  SubxCheckoutPopup.prototype._openRazorpayCheckout = function (payload) {
    var self = this;
    loadRazorpayCheckout().then(function (Razorpay) {
      var options = {
        key: payload.key_id,
        prefill: payload.prefill || {},
        handler: function () {
          var done = function () {
            window.location.href = SUBX_ACCOUNT_SUBSCRIPTIONS_URL || (window.location.origin + '/account');
          };
          // Cart checkout: empty the cart now it has been paid for, or the customer
          // comes back to a cart still holding everything they just bought. Provisioning
          // is webhook-driven, so this never blocks it — redirect either way.
          if (self._options && self._options.isCart) {
            fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
              .then(done).catch(done);
            return;
          }
          done();
        },
        modal: {
          ondismiss: function () {
            self._setLoading(false);
          },
        },
      };
      if (payload.subscription_id) {
        options.subscription_id = payload.subscription_id;
      } else {
        options.order_id = payload.order_id;
        options.customer_id = payload.customer_id;
        options.recurring = true;
      }
      var rzp = new Razorpay(options);
      rzp.on('payment.failed', function (resp) {
        self._setLoading(false);
        self._showGlobalError((resp && resp.error && resp.error.description) || 'Payment failed. Please try again.');
      });
      rzp.open();
    }).catch(function (err) {
      console.error('[SubxCheckoutPopup] Razorpay Checkout load failed:', err);
      if (payload.redirect_url) {
        // Better than a dead end: fall back to the hosted page if the script failed to load.
        window.location.href = payload.redirect_url;
      } else {
        self._setLoading(false);
        self._showGlobalError('Could not open payment window. Please try again.');
      }
    });
  };

  if (!window.SUBXCheckoutPopup) {
    console.log('[SUBX-FIX] First load — creating window.SUBXCheckoutPopup.');
    window.SUBXCheckoutPopup = new SubxCheckoutPopup();
  } else {
    console.warn('[SUBX-FIX] Duplicate script execution detected — window.SUBXCheckoutPopup already existed, skipped creating a second popup instance.');
  }
}());